import React, { useContext } from 'react';

var ThemeContext = React.createContext(null);

var ThemeProvider = function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'v1' : _ref$theme,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? [] : _ref$components,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      theme: theme,
      components: components
    }
  }, children);
};

// Theme from component prop has higher priority

function useTheme() {
  var componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var themeContext = useContext(ThemeContext);

  if (theme) {
    return theme;
  }

  if (themeContext) {
    var themeFromContext = themeContext.theme,
        components = themeContext.components;

    if (!components.length || components.length && components.includes(componentName)) {
      return themeFromContext;
    }
  }

  return null;
}

const ppuiBorderWidthNone = "0rem";
const ppuiBorderWidthXs = "0.0625rem";
const ppuiBorderWidthSm = "0.125rem";
const ppuiBorderRadiusXs = "0.125rem";
const ppuiBorderRadiusSm = "0.25rem";
const ppuiBorderRadiusLg = "0.75rem";
const ppuiBorderRadiusCircle = "50%";
const ppuiColorBlack = "#000000";
const ppuiColorWhite = "#ffffff";
const ppuiColorTransparent = "rgba(0, 0, 0, 0)";
const ppuiColorBlue100 = "#f5fbfe";
const ppuiColorBlue200 = "#e4f1fb";
const ppuiColorBlue300 = "#bfdbee";
const ppuiColorBlue400 = "#50c7f9";
const ppuiColorBlue500 = "#009cde";
const ppuiColorBlue600 = "#0070ba";
const ppuiColorBlue700 = "#005ea6";
const ppuiColorBlue800 = "#003087";
const ppuiColorGrey100 = "#f5f7fa";
const ppuiColorGrey200 = "#eaeced";
const ppuiColorGrey300 = "#cbd2d6";
const ppuiColorGrey400 = "#b7bcbf";
const ppuiColorGrey500 = "#9da3a6";
const ppuiColorGrey600 = "#687173";
const ppuiColorGrey700 = "#2c2e2f";
const ppuiColorGreen100 = "#f5fdfb";
const ppuiColorGreen500 = "#00cf92";
const ppuiColorGreen600 = "#299976";
const ppuiColorGreen700 = "#018065";
const ppuiColorRed100 = "#fff7f7";
const ppuiColorRed500 = "#d20000";
const ppuiColorOrange100 = "#fffbf5";
const ppuiColorOrange300 = "#ffbd5d";
const ppuiColorOrange500 = "#ff9600";
const ppuiColorOrange700 = "#d64003";
const ppuiColorPurple500 = "#640487";
const ppuiColorPink500 = "#de0063";
const ppuiColorBorderForm = "#909697";
const ppuiColorError = ppuiColorRed500;
const ppuiColorSuccess = ppuiColorGreen600;
const ppuiColorBackgroundSelected = ppuiColorBlue600;
const ppuiColorIconLink = ppuiColorBlue600;
const ppuiColorTextSupporting = ppuiColorGrey600;
const ppuiColorTextForm = ppuiColorBlack;
const ppuiColorTextPrimary = ppuiColorGrey700;
const ppuiColorTextLink = ppuiColorBlue600;
const ppuiFontFamily100 = "PayPalSansSmall-Regular";
const ppuiFontFamily200 = "PayPalSansSmall-Medium";
const ppuiFontFamily300 = "PayPalSansBig-Light";
const ppuiFontFamily400 = "PayPalSansBig-Regular";
const ppuiFontFamily500 = "PayPalSansBig-Medium";
const ppuiFontSizeXs = "0.6875rem";
const ppuiFontSizeSm = "0.8125rem";
const ppuiFontSizeMd = "0.9375rem";
const ppuiFontSizeLg = "1.125rem";
const ppuiFontSizeXl = "1.25rem";
const ppuiFontSizeXl2 = "1.5rem";
const ppuiFontSizeXl3 = "1.875rem";
const ppuiFontSizeXl4 = "2.5rem";
const ppuiFontSizeXl5 = "3.125rem";
const ppuiFontSizeXl6 = "3.75rem";
const ppuiFontSizeXl7 = "4.5rem";
const ppuiFontSizeXl8 = "5rem";
const ppuiLineHeightXs = "0.9375rem";
const ppuiLineHeightSm = "1.125rem";
const ppuiLineHeightMd = "1.5rem";
const ppuiLineHeightLg = "1.875rem";
const ppuiLineHeightXl = "2.25rem";
const ppuiLineHeightXl2 = "3rem";
const ppuiLineHeightXl3 = "3.75rem";
const ppuiLineHeightXl4 = "4.5rem";
const ppuiLineHeightXl5 = "5.25rem";
const ppuiLineHeightXl6 = "6rem";
const ppuiOpacityNone = 0;
const ppuiOpacityLow = 0.16;
const ppuiOpacityMedium = 0.4;
const ppuiOpacityHigh = 0.72;
const ppuiOpacityFull = 1;
const ppuiSizeXs = "1.125rem";
const ppuiSizeSm = "1.5rem";
const ppuiSizeMd = "1.875rem";
const ppuiSizeLg = "2.25rem";
const ppuiSizeXl = "2.5rem";
const ppuiSizeXl2 = "3rem";
const ppuiSizeText100 = "0.875rem";
const ppuiSizeText200 = "1rem";
const ppuiSizeText300 = "1.125rem";
const ppuiSizeText400 = "1.25rem";
const ppuiSizeText500 = "1.5rem";
const ppuiSizeText600 = "2rem";
const ppuiSizeText700 = "2.5rem";
const ppuiSizeText800 = "4rem";
const ppuiSizeLine100 = "1.25rem";
const ppuiSizeLine200 = "1.5rem";
const ppuiSizeLine300 = "1.625rem";
const ppuiSizeLine400 = "1.75rem";
const ppuiSizeLine500 = "2rem";
const ppuiSizeLine600 = "2.5rem";
const ppuiSizeLine700 = "3rem";
const ppuiSizeLine800 = "4.5rem";
const ppuiSpacingXs = "0.25rem";
const ppuiSpacingSm = "0.375rem";
const ppuiSpacingMd = "0.5rem";
const ppuiSpacingLg = "0.75rem";
const ppuiSpacingXl = "1rem";
const ppuiSpacingXl2 = "1.5rem";
const ppuiSpacingXl3 = "2rem";
const ppuiSpacingXl4 = "3rem";
const ppuiSpacingXl5 = "4.5rem";
const ppuiTimeInstant = "0.00s";
const ppuiTimeShort = "0.10s";
const ppuiTimeMedium = "0.20s";
const ppuiTimeLong = "0.30s";
const ppuiV2ColorNeutral100 = "#f7f5f0";
const ppuiV2ColorNeutral200 = "#f1efea";
const ppuiV2ColorNeutral300 = "#dbd8d0";
const ppuiV2ColorWhite = "#ffffff";
const ppuiV2ColorGrey50 = "#fafafa";
const ppuiV2ColorGrey300 = "#acadad";
const ppuiV2ColorGrey400 = "#909191";
const ppuiV2ColorGrey500 = "#757676";
const ppuiV2ColorGrey600 = "#515354";
const ppuiV2ColorBlack = "#0c0c0d";
const ppuiV2ColorBlue100 = "#d1f1ff";
const ppuiV2ColorBlue200 = "#9ee0fe";
const ppuiV2ColorBlue300 = "#56ccfe";
const ppuiV2ColorBlue400 = "#1072eb";
const ppuiV2ColorBlue500 = "#1040c1";
const ppuiV2ColorBlue600 = "#142c8e";
const ppuiV2ColorBlue700 = "#121661";
const ppuiV2ColorGold = "#ffc43a";
const ppuiV2ColorMagenta100 = "#ffcfef";
const ppuiV2ColorMagenta200 = "#f589d0";
const ppuiV2ColorMagenta300 = "#e557b4";
const ppuiV2ColorMagenta400 = "#c73193";
const ppuiV2ColorMagenta500 = "#9c2874";
const ppuiV2ColorMagenta600 = "#6c1b50";
const ppuiV2ColorOrange100 = "#fddbd3";
const ppuiV2ColorOrange200 = "#f9967b";
const ppuiV2ColorOrange300 = "#f55e36";
const ppuiV2ColorOrange400 = "#d9360b";
const ppuiV2ColorOrange500 = "#ad2b09";
const ppuiV2ColorOrange600 = "#791e06";
const ppuiV2ColorGreen100 = "#cbf3ec";
const ppuiV2ColorGreen200 = "#69d5ba";
const ppuiV2ColorGreen300 = "#38af88";
const ppuiV2ColorGreen400 = "#308a67";
const ppuiV2ColorGreen500 = "#25694f";
const ppuiV2ColorGreen600 = "#184634";
const ppuiV2ColorYellow100 = "#fff1a7";
const ppuiV2ColorYellow200 = "#ffe350";
const ppuiV2ColorYellow300 = "#fed13c";
const ppuiV2ColorYellow400 = "#ffc43a";
const ppuiV2ColorYellow500 = "#d89700";
const ppuiV2ColorYellow600 = "#785504";
const ppuiV2ColorPurple100 = "#f2e6fe";
const ppuiV2ColorPurple200 = "#e1c2ff";
const ppuiV2ColorPurple300 = "#c089f7";
const ppuiV2ColorPurple400 = "#a250f5";
const ppuiV2ColorPurple500 = "#761ad3";
const ppuiV2ColorPurple600 = "#5b06b0";
const ppuiV2ColorIllustrationBlack = "#222324";
const ppuiV2ColorSkin100 = "#ffe2d3";
const ppuiV2ColorSkin200 = "#fdd9b3";
const ppuiV2ColorSkin300 = "#e9c196";
const ppuiV2ColorSkin400 = "#dda97d";
const ppuiV2ColorSkin500 = "#c58c5f";
const ppuiV2ColorSkin600 = "#a26033";
const ppuiV2ColorSkin700 = "#73422f";
const ppuiV2ColorSkin800 = "#4f3631";
const ppuiV2ColorShadowScrimBlack = "#000000";
const ppuiV2SizeText100 = "0.875rem";
const ppuiV2SizeText300 = "1.125rem";
const ppuiV2SizeText500 = "1.75rem";
const ppuiV2SizeText700 = "2.75rem";
const ppuiV2SizeText900 = "4.5rem";
const ppuiV2SizeLine100 = "1.25rem";
const ppuiV2SizeLine200 = "1.5rem";
const ppuiV2SizeLine500 = "2.25rem";
const ppuiV2SizeLine700 = "3rem";
const ppuiV2SizeLine800 = "4.875rem";
const ppuiActionMenuWidthMin = "8rem";
const ppuiActionMenuWidthMax = "67.5rem";
const ppuiActionMenuHeightMax = "30rem";
const ppuiActionMenuBackgroundColor = ppuiColorWhite;
const ppuiActionMenuBackgroundSpaceTop = ppuiSpacingMd;
const ppuiActionMenuBackgroundSpaceBottom = ppuiSpacingMd;
const ppuiActionMenuBackgroundRadius = ppuiBorderRadiusSm;
const ppuiActionMenuItemBackgroundSpaceTop = ppuiSpacingMd;
const ppuiActionMenuItemBackgroundSpaceBottom = ppuiSpacingMd;
const ppuiActionMenuItemBackgroundSpaceLeft = ppuiSpacingXl;
const ppuiActionMenuItemBackgroundSpaceRight = ppuiSpacingXl;
const ppuiActionMenuItemTextColor = ppuiColorGrey700;
const ppuiActionMenuItemIconSize = ppuiSizeMd;
const ppuiActionMenuItemIconColor = ppuiColorBlue600;
const ppuiActionMenuItemIconSpaceRight = ppuiSpacingLg;
const ppuiBannerBackgroundSpaceTop = ppuiSpacingXl;
const ppuiBannerBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiBannerBackgroundColorCritical = ppuiColorRed500;
const ppuiBannerBackgroundColorWarning = ppuiColorOrange300;
const ppuiBannerTextColorCritical = ppuiColorWhite;
const ppuiBannerTextColorWarning = ppuiColorGrey700;
const ppuiBannerIconColorCritical = ppuiColorWhite;
const ppuiBannerIconColorWarning = ppuiColorGrey700;
const ppuiBannerIconSize = ppuiSizeXs;
const ppuiBannerIconAffordanceSize = ppuiSizeSm;
const ppuiBannerIconSpaceTop = "0.1875rem";
const ppuiBannerIconSpaceRight = ppuiSpacingLg;
const ppuiButtonBackgroundColorBranded = "#ffc43a";
const ppuiButtonBackgroundColorBrandedHover = "#ffb700";
const ppuiButtonTextColorBranded = "#012169";
const ppuiCheckboxTextLabelColor = ppuiColorTextPrimary;
const ppuiCheckboxTextSpaceBottom = ppuiSpacingXs;
const ppuiCheckboxIconInfoColor = ppuiColorIconLink;
const ppuiCheckboxIconInfoSpaceLeft = ppuiSpacingLg;
const ppuiCheckboxItemSpaceTop = ppuiSpacingMd;
const ppuiCheckboxItemSpaceBottom = ppuiSpacingMd;
const ppuiCheckboxItemIndicatorHeight = ppuiSizeSm;
const ppuiCheckboxItemIndicatorWidth = ppuiSizeSm;
const ppuiCheckboxItemIndicatorBackgroundColor = ppuiColorWhite;
const ppuiCheckboxItemIndicatorBackgroundColorSelected = ppuiColorBackgroundSelected;
const ppuiCheckboxItemIndicatorBorderSize = ppuiBorderWidthXs;
const ppuiCheckboxItemIndicatorBorderSizeSelected = ppuiBorderWidthNone;
const ppuiCheckboxItemIndicatorBorderSizeError = ppuiBorderWidthSm;
const ppuiCheckboxItemIndicatorBorderColor = ppuiColorBorderForm;
const ppuiCheckboxItemIndicatorBorderColorSelected = ppuiColorBackgroundSelected;
const ppuiCheckboxItemIndicatorBorderColorError = ppuiColorError;
const ppuiCheckboxItemIndicatorBorderRadius = ppuiBorderRadiusSm;
const ppuiCheckboxItemIndicatorIconColor = ppuiColorWhite;
const ppuiCheckboxItemTextColor = ppuiColorTextForm;
const ppuiCheckboxItemTextSpaceLeft = ppuiSpacingLg;
const ppuiCheckboxFooterSpaceTop = ppuiSpacingXs;
const ppuiCheckboxFooterTextColor = ppuiColorTextSupporting;
const ppuiCheckboxFooterTextColorError = ppuiColorTextPrimary;
const ppuiCheckboxFooterIconColorError = ppuiColorError;
const ppuiCheckboxFooterIconSpaceRight = ppuiSpacingLg;
const ppuiCoachtipBorderColor = ppuiColorWhite;
const ppuiCoachtipBorderWidth = ppuiBorderWidthXs;
const ppuiCoachtipBorderRadius = ppuiBorderRadiusSm;
const ppuiCoachtipWidthMax = "20rem";
const ppuiCoachtipBackgroundColor = ppuiColorGrey700;
const ppuiCoachtipBackgroundSpaceTop = ppuiSpacingXl2;
const ppuiCoachtipBackgroundSpaceBottom = ppuiSpacingXl2;
const ppuiCoachtipBackgroundSpaceLeft = ppuiSpacingXl2;
const ppuiCoachtipBackgroundSpaceRight = ppuiSpacingXl2;
const ppuiCoachtipCaretWidth = "0.9375rem";
const ppuiCoachtipCaretHeight = "0.5625rem";
const ppuiCoachtipCaretOffset = ppuiSpacingXs;
const ppuiCoachtipIconCloseColor = ppuiColorWhite;
const ppuiCoachtipIconCloseSpacingLeft = ppuiSpacingLg;
const ppuiCoachtipTextColor = ppuiColorWhite;
const ppuiCoachtipTextHeadingSpaceBottom = ppuiSpacingLg;
const ppuiCoachtipTextPaginationSpaceRight = ppuiSpacingLg;
const ppuiCoachtipFooterButtonSpaceLeft = ppuiSpacingLg;
const ppuiCoachtipFooterSpaceTop = ppuiSpacingLg;
const ppuiDropdownBackgroundColor = ppuiColorWhite;
const ppuiDropdownBackgroundSpaceLeft = ppuiSpacingLg;
const ppuiDropdownBackgroundSpaceRight = ppuiSpacingLg;
const ppuiDropdownBackgroundSpaceTop = ppuiSpacingXl;
const ppuiDropdownBackgroundSpaceTopEntered = "0.4375rem";
const ppuiDropdownBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiDropdownBackgroundSpaceBottomEntered = "0.4375rem";
const ppuiDropdownBorderColor = ppuiColorBorderForm;
const ppuiDropdownBorderColorError = ppuiColorError;
const ppuiDropdownBorderSize = ppuiBorderWidthXs;
const ppuiDropdownBorderSizeError = ppuiBorderWidthSm;
const ppuiDropdownBorderRadius = ppuiBorderRadiusSm;
const ppuiDropdownIconRightSpaceTop = ppuiSpacingXs;
const ppuiDropdownIconRightSpaceLeft = ppuiSpacingLg;
const ppuiDropdownIconRightColor = ppuiColorGrey600;
const ppuiDropdownTextColor = ppuiColorTextForm;
const ppuiDropdownTextLabelColor = ppuiColorTextSupporting;
const ppuiDropdownFooterSpaceTop = ppuiSpacingMd;
const ppuiDropdownFooterTextColor = ppuiColorTextSupporting;
const ppuiDropdownFooterTextColorError = ppuiColorTextPrimary;
const ppuiDropdownFooterIconColorError = ppuiColorError;
const ppuiDropdownFooterIconColorSuccess = ppuiColorSuccess;
const ppuiDropdownFooterIconSpaceRight = ppuiSpacingLg;
const ppuiElevationShadowColorLevel1 = ppuiColorBlack;
const ppuiElevationShadowColorLevel2 = ppuiColorBlack;
const ppuiElevationShadowColorLevel3 = ppuiColorBlack;
const ppuiElevationShadowColorLevel4 = ppuiColorBlack;
const ppuiElevationShadowColorLevel5 = ppuiColorBlack;
const ppuiElevationShadowOpacityLevel1 = ppuiOpacityLow;
const ppuiElevationShadowOpacityLevel2 = ppuiOpacityLow;
const ppuiElevationShadowOpacityLevel3 = ppuiOpacityLow;
const ppuiElevationShadowOpacityLevel4 = ppuiOpacityLow;
const ppuiElevationShadowOpacityLevel5 = ppuiOpacityLow;
const ppuiElevationShadowPositionHorizontalLevel1 = "0rem";
const ppuiElevationShadowPositionHorizontalLevel2 = "0rem";
const ppuiElevationShadowPositionHorizontalLevel3 = "0rem";
const ppuiElevationShadowPositionHorizontalLevel4 = "0rem";
const ppuiElevationShadowPositionHorizontalLevel5 = "0rem";
const ppuiElevationShadowPositionVerticalLevel1 = "0.125rem";
const ppuiElevationShadowPositionVerticalLevel2 = "0.1875rem";
const ppuiElevationShadowPositionVerticalLevel3 = ppuiSpacingXs;
const ppuiElevationShadowPositionVerticalLevel4 = ppuiSpacingSm;
const ppuiElevationShadowPositionVerticalLevel5 = ppuiSpacingLg;
const ppuiElevationShadowBlurLevel1 = ppuiSpacingXs;
const ppuiElevationShadowBlurLevel2 = "0.625rem";
const ppuiElevationShadowBlurLevel3 = ppuiSpacingXl;
const ppuiElevationShadowBlurLevel4 = "1.25rem";
const ppuiElevationShadowBlurLevel5 = "1.75rem";
const ppuiFlagWidthXs = "1rem";
const ppuiFlagWidthSm = ppuiSizeSm;
const ppuiFlagWidthMd = "2rem";
const ppuiFlagHeightXs = "0.75rem";
const ppuiFlagHeightSm = ppuiSizeXs;
const ppuiFlagHeightMd = ppuiSizeSm;
const ppuiFlagBorderWidth = ppuiBorderWidthXs;
const ppuiFlagBorderColor = ppuiColorGrey300;
const ppuiFlagBorderRadiusXs = ppuiBorderRadiusXs;
const ppuiFlagBorderRadiusSm = ppuiBorderRadiusSm;
const ppuiFlagBorderRadiusMd = ppuiBorderRadiusSm;
const ppuiIconbuttonIconSize = ppuiSizeSm;
const ppuiIconbuttonIconColor = ppuiColorGrey700;
const ppuiIconbuttonIconColorInverse = ppuiColorWhite;
const ppuiIconbuttonIconSpaceTop = ppuiSpacingLg;
const ppuiIconbuttonIconSpaceBottom = ppuiSpacingLg;
const ppuiIconbuttonIconSpaceLeft = ppuiSpacingLg;
const ppuiIconbuttonIconSpaceRight = ppuiSpacingLg;
const ppuiMotionBezierEasingX1 = 0;
const ppuiMotionBezierEasingY1 = 0.9;
const ppuiMotionBezierEasingX2 = 0.3;
const ppuiMotionBezierEasingY2 = 1;
const ppuiMultiselectgroupTextLabelColor = ppuiColorTextPrimary;
const ppuiMultiselectgroupTextLabelSpaceBottom = ppuiSpacingLg;
const ppuiMultiselectgroupIconInfoColor = ppuiColorIconLink;
const ppuiMultiselectgroupIconInfoSpaceLeft = ppuiSpacingLg;
const ppuiMultiselectgroupItemSpace = ppuiSpacingLg;
const ppuiMultiselectgroupItemBackgroundColor = ppuiColorWhite;
const ppuiMultiselectgroupItemBackgroundColorSelected = ppuiColorBackgroundSelected;
const ppuiMultiselectgroupItemBackgroundColorSecondarySelected = ppuiColorBlue200;
const ppuiMultiselectgroupItemBackgroundSpaceTop = ppuiSpacingXl;
const ppuiMultiselectgroupItemBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiMultiselectgroupItemBackgroundSpaceLeft = ppuiSpacingXl2;
const ppuiMultiselectgroupItemBackgroundSpaceRight = ppuiSpacingXl2;
const ppuiMultiselectgroupItemBorderSize = ppuiBorderWidthXs;
const ppuiMultiselectgroupItemBorderSizeSelected = ppuiBorderWidthNone;
const ppuiMultiselectgroupItemBorderSizeSecondarySelected = "0.1875rem";
const ppuiMultiselectgroupItemBorderSizeError = ppuiBorderWidthSm;
const ppuiMultiselectgroupItemBorderColor = ppuiColorBorderForm;
const ppuiMultiselectgroupItemBorderColorSelected = ppuiColorBackgroundSelected;
const ppuiMultiselectgroupItemBorderColorError = ppuiColorError;
const ppuiMultiselectgroupItemBorderRadius = ppuiBorderRadiusSm;
const ppuiMultiselectgroupItemTextColor = ppuiColorTextLink;
const ppuiMultiselectgroupItemTextColorSelected = ppuiColorWhite;
const ppuiMultiselectgroupItemTextColorSecondarySelected = ppuiColorTextLink;
const ppuiMultiselectgroupFooterSpaceTop = ppuiSpacingMd;
const ppuiMultiselectgroupFooterTextColor = ppuiColorTextSupporting;
const ppuiMultiselectgroupFooterTextColorError = ppuiColorTextPrimary;
const ppuiMultiselectgroupFooterIconColorError = ppuiColorError;
const ppuiMultiselectgroupFooterIconSpaceRight = ppuiSpacingLg;
const ppuiRadiobuttonTextLabelColor = ppuiColorTextPrimary;
const ppuiRadiobuttonTextLabelSpaceBottom = ppuiSpacingXs;
const ppuiRadiobuttonIconInfoColor = ppuiColorIconLink;
const ppuiRadiobuttonIconInfoSpaceLeft = ppuiSpacingLg;
const ppuiRadiobuttonItemSpaceTop = ppuiSpacingMd;
const ppuiRadiobuttonItemSpaceBottom = ppuiSpacingMd;
const ppuiRadiobuttonItemIndicatorHeight = ppuiSizeSm;
const ppuiRadiobuttonItemIndicatorWidth = ppuiSizeSm;
const ppuiRadiobuttonItemIndicatorBackgroundColor = ppuiColorWhite;
const ppuiRadiobuttonItemIndicatorBackgroundColorSelected = ppuiColorBackgroundSelected;
const ppuiRadiobuttonItemIndicatorBorderSize = ppuiBorderWidthXs;
const ppuiRadiobuttonItemIndicatorBorderSizeSelected = ppuiBorderWidthNone;
const ppuiRadiobuttonItemIndicatorBorderSizeError = ppuiBorderWidthSm;
const ppuiRadiobuttonItemIndicatorBorderColor = ppuiColorBorderForm;
const ppuiRadiobuttonItemIndicatorBorderColorSelected = ppuiColorBackgroundSelected;
const ppuiRadiobuttonItemIndicatorBorderColorError = ppuiColorError;
const ppuiRadiobuttonItemIndicatorDotColor = ppuiColorWhite;
const ppuiRadiobuttonItemIndicatorDotSize = "0.5rem";
const ppuiRadiobuttonItemTextColor = ppuiColorTextForm;
const ppuiRadiobuttonItemTextSpaceLeft = ppuiSpacingLg;
const ppuiRadiobuttonFooterSpaceTop = ppuiSpacingXs;
const ppuiRadiobuttonFooterTextColor = ppuiColorTextSupporting;
const ppuiRadiobuttonFooterTextColorError = ppuiColorTextPrimary;
const ppuiRadiobuttonFooterIconColorError = ppuiColorError;
const ppuiRadiobuttonFooterIconSpaceRight = ppuiSpacingLg;
const ppuiSelectionMenuWidthMin = "8rem";
const ppuiSelectionMenuWidthMax = "67.5rem";
const ppuiSelectionMenuHeightMax = "30rem";
const ppuiSelectionMenuBackgroundColor = ppuiColorWhite;
const ppuiSelectionMenuBackgroundRadius = ppuiBorderRadiusSm;
const ppuiSelectionMenuBackgroundSpaceTop = ppuiSpacingMd;
const ppuiSelectionMenuBackgroundSpaceBottom = ppuiSpacingMd;
const ppuiSelectionMenuItemBackgroundSpaceTop = ppuiSpacingMd;
const ppuiSelectionMenuItemBackgroundSpaceBottom = ppuiSpacingMd;
const ppuiSelectionMenuItemBackgroundSpaceLeft = ppuiSpacingXl;
const ppuiSelectionMenuItemBackgroundSpaceRight = ppuiSpacingXl;
const ppuiSelectionMenuItemTextColor = ppuiColorGrey700;
const ppuiSelectionMenuItemTextSecondaryColor = ppuiColorGrey600;
const ppuiSelectionMenuItemThumbnailSpaceRight = ppuiSpacingXl;
const ppuiSelectionMenuItemThumbnailSpaceTopMultiline = ppuiSpacingXs;
const ppuiSelectionMenuItemThumbnailImageWidth = ppuiSizeMd;
const ppuiSelectionMenuItemThumbnailImageHeight = ppuiSizeMd;
const ppuiSelectionMenuItemThumbnailImageRadius = ppuiBorderRadiusXs;
const ppuiSelectionMenuItemIconIndicatorSize = ppuiSizeXs;
const ppuiSelectionMenuItemIconIndicatorColor = ppuiColorBlue600;
const ppuiSelectionMenuItemIconIndicatorSpaceLeft = ppuiSpacingXl;
const ppuiSheetBackgroundColor = ppuiColorWhite;
const ppuiSheetBackgroundRadius = ppuiBorderRadiusLg;
const ppuiSheetScrimColor = ppuiColorBlack;
const ppuiSheetScrimOpacity = ppuiOpacityMedium;
const ppuiSheetGripperColor = ppuiColorGrey500;
const ppuiSheetGripperWidth = ppuiSizeXl2;
const ppuiSheetGripperHeight = "0.5rem";
const ppuiSheetGripperSpaceTop = ppuiSpacingMd;
const ppuiSheetHeaderSpaceTop = ppuiSpacingXl;
const ppuiSheetHeaderSpaceBottom = ppuiSpacingXl;
const ppuiSheetHeaderSpaceLeft = ppuiSpacingXl;
const ppuiSheetHeaderSpaceRight = ppuiSpacingXl;
const ppuiSheetHeaderBackgroundColor = ppuiColorWhite;
const ppuiSheetHeaderIconCloseColor = ppuiColorGrey600;
const ppuiSheetHeaderIconCloseSize = ppuiSizeSm;
const ppuiSheetHeaderIconCloseSpaceLeft = ppuiSpacingXl;
const ppuiSheetHeaderTextHeadingColor = ppuiColorGrey700;
const ppuiSheetAnimationDurationCurveEnter = ppuiTimeLong;
const ppuiSheetAnimationDurationCurveExit = ppuiTimeLong;
const ppuiSheetTextHeadingColor = ppuiColorGrey700;
const ppuiSheetTextColor = ppuiColorGrey700;
const ppuiSheetFooterSpaceTop = ppuiSpacingXl;
const ppuiSheetFooterSpaceBottom = ppuiSpacingXl;
const ppuiSheetFooterSpaceLeft = ppuiSpacingXl;
const ppuiSheetFooterSpaceRight = ppuiSpacingXl;
const ppuiSheetFooterColor = ppuiColorWhite;
const ppuiSingleselectgroupTextLabelColor = ppuiColorTextPrimary;
const ppuiSingleselectgroupTextLabelSpaceBottom = ppuiSpacingLg;
const ppuiSingleselectgroupIconInfoColor = ppuiColorIconLink;
const ppuiSingleselectgroupIconInfoSpaceLeft = ppuiSpacingLg;
const ppuiSingleselectgroupBorderRadius = ppuiBorderRadiusSm;
const ppuiSingleselectgroupBorderSize = ppuiBorderWidthXs;
const ppuiSingleselectgroupBorderSizeError = ppuiBorderWidthSm;
const ppuiSingleselectgroupBorderColor = ppuiColorBorderForm;
const ppuiSingleselectgroupBorderColorError = ppuiColorError;
const ppuiSingleselectgroupDividerSize = ppuiBorderWidthXs;
const ppuiSingleselectgroupDividerColor = ppuiColorBorderForm;
const ppuiSingleselectgroupItemBackgroundColor = ppuiColorWhite;
const ppuiSingleselectgroupItemBackgroundColorSelected = ppuiColorBackgroundSelected;
const ppuiSingleselectgroupItemBackgroundColorSecondarySelected = ppuiColorBlue200;
const ppuiSingleselectgroupItemBackgroundSpaceTop = ppuiSpacingXl;
const ppuiSingleselectgroupItemBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiSingleselectgroupItemBackgroundSpaceLeft = ppuiSpacingXl2;
const ppuiSingleselectgroupItemBackgroundSpaceRight = ppuiSpacingXl2;
const ppuiSingleselectgroupItemBorderSizeSelected = ppuiBorderWidthNone;
const ppuiSingleselectgroupItemBorderSizeSecondarySelected = "0.1875rem";
const ppuiSingleselectgroupItemBorderColorSelected = ppuiColorBackgroundSelected;
const ppuiSingleselectgroupItemTextColor = ppuiColorTextLink;
const ppuiSingleselectgroupItemTextColorSelected = ppuiColorWhite;
const ppuiSingleselectgroupItemTextColorSecondarySelected = ppuiColorTextLink;
const ppuiSingleselectgroupFooterSpaceTop = ppuiSpacingMd;
const ppuiSingleselectgroupFooterTextColor = ppuiColorTextSupporting;
const ppuiSingleselectgroupFooterTextColorError = ppuiColorTextPrimary;
const ppuiSingleselectgroupFooterIconColorError = ppuiColorError;
const ppuiSingleselectgroupFooterIconSpaceRight = ppuiSpacingLg;
const ppuiStatesOverlayColorPressed = ppuiColorGrey700;
const ppuiStatesOverlayColorActive = ppuiColorGrey700;
const ppuiStatesOverlayColorInversePressed = ppuiColorWhite;
const ppuiStatesOverlayColorInverseActive = ppuiColorWhite;
const ppuiStatesOverlayColorInverseHover = ppuiColorWhite;
const ppuiStatesOverlayColorHover = ppuiColorGrey700;
const ppuiStatesOverlayOpacityPressed = 0.12;
const ppuiStatesOverlayOpacityActive = 0.12;
const ppuiStatesOverlayOpacityInversePressed = ppuiOpacityLow;
const ppuiStatesOverlayOpacityInverseActive = ppuiOpacityLow;
const ppuiStatesOverlayOpacityInverseHover = 0.08;
const ppuiStatesOverlayOpacityHover = 0.08;
const ppuiStatesAnimationDurationPressedDown = ppuiTimeShort;
const ppuiStatesAnimationDurationPressedUp = "0.60s";
const ppuiStatesAnimationDurationHoverOver = ppuiTimeShort;
const ppuiStatesAnimationDurationHoverOut = ppuiTimeShort;
const ppuiStatesOutlineInnerColorFocus = ppuiColorBlue600;
const ppuiStatesOutlineInnerColorInverseFocus = ppuiColorBlue300;
const ppuiStatesOutlineInnerSizeFocus = "0.125rem";
const ppuiStatesOutlineOuterColorFocus = ppuiColorBlue300;
const ppuiStatesOutlineOuterColorInverseFocus = ppuiColorBlue300;
const ppuiStatesOutlineOuterOpacityInverseFocus = ppuiOpacityMedium;
const ppuiStatesOutlineOuterSizeFocus = "0.25rem";
const ppuiStatesOutlineOffsetSizeFocus = "0rem";
const ppuiSwitchTextLabelColor = ppuiColorTextPrimary;
const ppuiSwitchTextLabelSpaceBottom = ppuiSpacingLg;
const ppuiSwitchIconInfoColor = ppuiColorIconLink;
const ppuiSwitchIconInfoSpaceLeft = ppuiSpacingLg;
const ppuiSwitchIndicatorWidth = "3.5rem";
const ppuiSwitchIndicatorHeight = "2rem";
const ppuiSwitchIndicatorBackgroundColor = ppuiColorWhite;
const ppuiSwitchIndicatorBackgroundColorOn = ppuiColorBackgroundSelected;
const ppuiSwitchIndicatorBackgroundSpaceLeft = ppuiSpacingMd;
const ppuiSwitchIndicatorBackgroundSpaceRight = ppuiSpacingMd;
const ppuiSwitchIndicatorBorderSize = ppuiBorderWidthXs;
const ppuiSwitchIndicatorBorderSizeOn = ppuiBorderWidthNone;
const ppuiSwitchIndicatorBorderSizeError = ppuiBorderWidthSm;
const ppuiSwitchIndicatorBorderColor = ppuiColorBorderForm;
const ppuiSwitchIndicatorBorderColorOn = ppuiColorBackgroundSelected;
const ppuiSwitchIndicatorBorderColorError = ppuiColorError;
const ppuiSwitchIndicatorHandleColor = ppuiColorGrey600;
const ppuiSwitchIndicatorHandleColorOn = ppuiColorWhite;
const ppuiSwitchIndicatorHandleSize = "1rem";
const ppuiSwitchIndicatorTextColor = ppuiColorTextForm;
const ppuiSwitchIndicatorTextSpaceLeft = ppuiSpacingLg;
const ppuiSwitchFooterSpaceTop = ppuiSpacingXs;
const ppuiSwitchFooterTextColor = ppuiColorTextSupporting;
const ppuiSwitchFooterTextColorError = ppuiColorTextPrimary;
const ppuiSwitchFooterIconColorError = ppuiColorError;
const ppuiSwitchFooterIconSpaceRight = ppuiSpacingLg;
const ppuiTextareaHeightMin = "4.5rem";
const ppuiTextareaHeightMax = "12.5rem";
const ppuiTextareaBackgroundColor = ppuiColorWhite;
const ppuiTextareaBackgroundSpaceLeft = ppuiSpacingLg;
const ppuiTextareaBackgroundSpaceRight = ppuiSpacingLg;
const ppuiTextareaBackgroundSpaceTop = ppuiSpacingXl;
const ppuiTextareaBackgroundSpaceTopEntered = "0.4375rem";
const ppuiTextareaBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiTextareaBackgroundSpaceBottomEntered = "0.4375rem";
const ppuiTextareaBorderColor = ppuiColorBorderForm;
const ppuiTextareaBorderColorError = ppuiColorError;
const ppuiTextareaBorderSize = ppuiBorderWidthXs;
const ppuiTextareaBorderSizeError = ppuiBorderWidthSm;
const ppuiTextareaBorderRadius = ppuiBorderRadiusSm;
const ppuiTextareaIconRightSpaceTop = ppuiSpacingXs;
const ppuiTextareaTextColor = ppuiColorTextForm;
const ppuiTextareaTextLabelColor = ppuiColorTextSupporting;
const ppuiTextareaTextLabelSpaceBottomEntered = ppuiSpacingXs;
const ppuiTextareaTextLabelSpaceTopEntered = ppuiSpacingXs;
const ppuiTextareaCounterBackgroundSpaceTop = ppuiSpacingMd;
const ppuiTextareaCounterBackgroundColor = ppuiColorWhite;
const ppuiTextareaCounterTextColor = ppuiColorTextSupporting;
const ppuiTextareaCounterTextColorError = ppuiColorError;
const ppuiTextareaFooterSpaceTop = ppuiSpacingMd;
const ppuiTextareaFooterTextColor = ppuiColorTextSupporting;
const ppuiTextareaFooterTextColorError = ppuiColorTextPrimary;
const ppuiTextareaFooterIconColorError = ppuiColorError;
const ppuiTextareaFooterIconSpaceRight = ppuiSpacingLg;
const ppuiTextinputBackgroundColor = ppuiColorWhite;
const ppuiTextinputBackgroundSpaceLeft = ppuiSpacingLg;
const ppuiTextinputBackgroundSpaceRight = ppuiSpacingLg;
const ppuiTextinputBackgroundSpaceTop = ppuiSpacingXl;
const ppuiTextinputBackgroundSpaceTopEntered = "0.4375rem";
const ppuiTextinputBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiTextinputBackgroundSpaceBottomEntered = "0.4375rem";
const ppuiTextinputBorderColor = ppuiColorBorderForm;
const ppuiTextinputBorderColorError = ppuiColorError;
const ppuiTextinputBorderSize = ppuiBorderWidthXs;
const ppuiTextinputBorderSizeError = ppuiBorderWidthSm;
const ppuiTextinputBorderRadius = ppuiBorderRadiusSm;
const ppuiTextinputIconLeftColor = ppuiColorGrey600;
const ppuiTextinputIconLeftSpaceRight = ppuiSpacingLg;
const ppuiTextinputIconLeftSpaceTop = ppuiSpacingXl;
const ppuiTextinputIconLeftSpaceLeft = ppuiSpacingLg;
const ppuiTextinputIconRightSpaceTop = ppuiSpacingXs;
const ppuiTextinputIconRightSpaceLeft = ppuiSpacingLg;
const ppuiTextinputIconRightSpaceRight = ppuiSpacingLg;
const ppuiTextinputTextColor = ppuiColorTextForm;
const ppuiTextinputTextLabelColor = ppuiColorTextSupporting;
const ppuiTextinputFooterSpaceTop = ppuiSpacingMd;
const ppuiTextinputFooterTextColor = ppuiColorTextSupporting;
const ppuiTextinputFooterTextColorError = ppuiColorTextPrimary;
const ppuiTextinputFooterTextColorSuccess = ppuiColorTextPrimary;
const ppuiTextinputFooterIconColorError = ppuiColorError;
const ppuiTextinputFooterIconColorSuccess = ppuiColorSuccess;
const ppuiTextinputFooterIconSpaceRight = ppuiSpacingLg;
const ppuiToastWidthMax = "30rem";
const ppuiToastBackgroundRadius = ppuiBorderRadiusSm;
const ppuiToastBackgroundSpaceTop = ppuiSpacingXl;
const ppuiToastBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiToastBackgroundSpaceLeft = ppuiSpacingXl;
const ppuiToastBackgroundSpaceRight = ppuiSpacingXl;
const ppuiToastBackgroundColorSuccess = ppuiColorGreen700;
const ppuiToastBackgroundColorInformational = ppuiColorGrey700;
const ppuiToastTextColor = ppuiColorWhite;
const ppuiToastIconSize = ppuiSizeXs;
const ppuiToastIconColor = ppuiColorWhite;
const ppuiToastIconSpaceTop = "0.1875rem";
const ppuiToastIconSpaceRight = ppuiSpacingMd;
const ppuiToastAnimationDurationActive = "7.00s";
const ppuiToastAnimationPositionVerticalActive = ppuiSpacingXl;
const ppuiToastAnimationPositionDeltaVerticalEnter = ppuiSpacingXl3;
const ppuiToastAnimationPositionDeltaVerticalExit = "-2rem";
const ppuiToastAnimationPositionDurationEnter = ppuiTimeLong;
const ppuiToastAnimationPositionDurationExit = ppuiTimeLong;
const ppuiToastAnimationOpacityActive = ppuiOpacityFull;
const ppuiToastAnimationOpacityInactive = ppuiOpacityNone;
const ppuiToastAnimationOpacityDurationEnter = ppuiTimeLong;
const ppuiToastAnimationOpacityDurationExit = ppuiTimeLong;
const ppuiTooltipBorderColor = ppuiColorBlue400;
const ppuiTooltipBorderWidth = ppuiBorderWidthXs;
const ppuiTooltipBorderRadius = ppuiBorderRadiusSm;
const ppuiTooltipWidthMax = "18rem";
const ppuiTooltipBackgroundColor = ppuiColorBlue100;
const ppuiTooltipBackgroundSpaceTop = ppuiSpacingXl;
const ppuiTooltipBackgroundSpaceBottom = ppuiSpacingXl;
const ppuiTooltipBackgroundSpaceLeft = ppuiSpacingXl;
const ppuiTooltipBackgroundSpaceRight = ppuiSpacingXl;
const ppuiTooltipCaretWidth = "0.9375rem";
const ppuiTooltipCaretHeight = "0.5625rem";
const ppuiTooltipCaretOffset = ppuiSpacingXs;
const ppuiTooltipCaretSpaceHorizontal = ppuiSpacingXl;
const ppuiTooltipTextColor = ppuiColorGrey700;
const ppuiTooltipTriggerColor = ppuiColorBlue600;
const ppuiTooltipTriggerTargetWidth = "2.75rem";
const ppuiTooltipTriggerTargetHeight = "2.75rem";
const ppuiV2ElevationShadowPositionHorizontalLevel1Top = "0rem";
const ppuiV2ElevationShadowPositionHorizontalLevel1Bottom = "0rem";
const ppuiV2ElevationShadowPositionHorizontalLevel2Top = "0rem";
const ppuiV2ElevationShadowPositionHorizontalLevel2Bottom = "0rem";
const ppuiV2ElevationShadowPositionHorizontalLevel3Top = "0rem";
const ppuiV2ElevationShadowPositionHorizontalLevel3Bottom = "0rem";
const ppuiV2ElevationShadowPositionVerticalLevel1Top = "0rem";
const ppuiV2ElevationShadowPositionVerticalLevel1Bottom = "0.0625rem";
const ppuiV2ElevationShadowPositionVerticalLevel2Top = "0rem";
const ppuiV2ElevationShadowPositionVerticalLevel2Bottom = "0.125rem";
const ppuiV2ElevationShadowPositionVerticalLevel3Top = "0rem";
const ppuiV2ElevationShadowPositionVerticalLevel3Bottom = "0.125rem";
const ppuiV2ElevationShadowBlurLevel1Top = "0.125rem";
const ppuiV2ElevationShadowBlurLevel1Bottom = "0.75rem";
const ppuiV2ElevationShadowBlurLevel2Top = "0.25rem";
const ppuiV2ElevationShadowBlurLevel2Bottom = "0.875rem";
const ppuiV2ElevationShadowBlurLevel3Top = "0.5rem";
const ppuiV2ElevationShadowBlurLevel3Bottom = "1.125rem";
const ppuiV2ElevationShadowColorLevel1Top = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowColorLevel1Bottom = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowColorLevel2Top = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowColorLevel2Bottom = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowColorLevel3Top = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowColorLevel3Bottom = ppuiV2ColorShadowScrimBlack;
const ppuiV2ElevationShadowOpacityLevel1Top = "0.04";
const ppuiV2ElevationShadowOpacityLevel1Bottom = "0.08";
const ppuiV2ElevationShadowOpacityLevel2Top = "0.06";
const ppuiV2ElevationShadowOpacityLevel2Bottom = "0.1";
const ppuiV2ElevationShadowOpacityLevel3Top = "0.04";
const ppuiV2ElevationShadowOpacityLevel3Bottom = "0.1";
const ppuiFontWeightLight = "300";
const ppuiFontWeightNormal = "500";
const ppuiFontWeightBold = "700";
const ppuiGridMediaQuerySm = "36rem";
const ppuiGridMediaQueryMd = "47rem";
const ppuiGridMediaQueryLg = "64rem";
const ppuiGridMediaQueryXl = "72rem";
const ppuiGridMediaQueryXxl = "90rem";
const ppuiGridGutter = "0.75rem";
const ppuiActionMenuItemBackgroundSpaceTopMweb = ppuiSpacingLg;
const ppuiActionMenuItemBackgroundSpaceBottomMweb = ppuiSpacingLg;
const ppuiAppbadgeIosHeight = "2.5rem";
const ppuiAppbadgeIosWidth = "7.5rem";
const ppuiAppbadgeAndroidHeight = "2.5rem";
const ppuiAppbadgeAndroidWidth = "8.4375rem";
const ppuiIconbuttonMenuSpaceTop = ppuiSpacingXs;
const ppuiSelectionMenuBackgroundRadiusMweb = ppuiBorderRadiusLg;
const ppuiSelectionMenuItemBackgroundSpaceTopMweb = ppuiSpacingLg;
const ppuiSelectionMenuItemBackgroundSpaceBottomMweb = ppuiSpacingLg;

var PPUI_TOKENS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ppuiBorderWidthNone: ppuiBorderWidthNone,
  ppuiBorderWidthXs: ppuiBorderWidthXs,
  ppuiBorderWidthSm: ppuiBorderWidthSm,
  ppuiBorderRadiusXs: ppuiBorderRadiusXs,
  ppuiBorderRadiusSm: ppuiBorderRadiusSm,
  ppuiBorderRadiusLg: ppuiBorderRadiusLg,
  ppuiBorderRadiusCircle: ppuiBorderRadiusCircle,
  ppuiColorBlack: ppuiColorBlack,
  ppuiColorWhite: ppuiColorWhite,
  ppuiColorTransparent: ppuiColorTransparent,
  ppuiColorBlue100: ppuiColorBlue100,
  ppuiColorBlue200: ppuiColorBlue200,
  ppuiColorBlue300: ppuiColorBlue300,
  ppuiColorBlue400: ppuiColorBlue400,
  ppuiColorBlue500: ppuiColorBlue500,
  ppuiColorBlue600: ppuiColorBlue600,
  ppuiColorBlue700: ppuiColorBlue700,
  ppuiColorBlue800: ppuiColorBlue800,
  ppuiColorGrey100: ppuiColorGrey100,
  ppuiColorGrey200: ppuiColorGrey200,
  ppuiColorGrey300: ppuiColorGrey300,
  ppuiColorGrey400: ppuiColorGrey400,
  ppuiColorGrey500: ppuiColorGrey500,
  ppuiColorGrey600: ppuiColorGrey600,
  ppuiColorGrey700: ppuiColorGrey700,
  ppuiColorGreen100: ppuiColorGreen100,
  ppuiColorGreen500: ppuiColorGreen500,
  ppuiColorGreen600: ppuiColorGreen600,
  ppuiColorGreen700: ppuiColorGreen700,
  ppuiColorRed100: ppuiColorRed100,
  ppuiColorRed500: ppuiColorRed500,
  ppuiColorOrange100: ppuiColorOrange100,
  ppuiColorOrange300: ppuiColorOrange300,
  ppuiColorOrange500: ppuiColorOrange500,
  ppuiColorOrange700: ppuiColorOrange700,
  ppuiColorPurple500: ppuiColorPurple500,
  ppuiColorPink500: ppuiColorPink500,
  ppuiColorBorderForm: ppuiColorBorderForm,
  ppuiColorError: ppuiColorError,
  ppuiColorSuccess: ppuiColorSuccess,
  ppuiColorBackgroundSelected: ppuiColorBackgroundSelected,
  ppuiColorIconLink: ppuiColorIconLink,
  ppuiColorTextSupporting: ppuiColorTextSupporting,
  ppuiColorTextForm: ppuiColorTextForm,
  ppuiColorTextPrimary: ppuiColorTextPrimary,
  ppuiColorTextLink: ppuiColorTextLink,
  ppuiFontFamily100: ppuiFontFamily100,
  ppuiFontFamily200: ppuiFontFamily200,
  ppuiFontFamily300: ppuiFontFamily300,
  ppuiFontFamily400: ppuiFontFamily400,
  ppuiFontFamily500: ppuiFontFamily500,
  ppuiFontSizeXs: ppuiFontSizeXs,
  ppuiFontSizeSm: ppuiFontSizeSm,
  ppuiFontSizeMd: ppuiFontSizeMd,
  ppuiFontSizeLg: ppuiFontSizeLg,
  ppuiFontSizeXl: ppuiFontSizeXl,
  ppuiFontSizeXl2: ppuiFontSizeXl2,
  ppuiFontSizeXl3: ppuiFontSizeXl3,
  ppuiFontSizeXl4: ppuiFontSizeXl4,
  ppuiFontSizeXl5: ppuiFontSizeXl5,
  ppuiFontSizeXl6: ppuiFontSizeXl6,
  ppuiFontSizeXl7: ppuiFontSizeXl7,
  ppuiFontSizeXl8: ppuiFontSizeXl8,
  ppuiLineHeightXs: ppuiLineHeightXs,
  ppuiLineHeightSm: ppuiLineHeightSm,
  ppuiLineHeightMd: ppuiLineHeightMd,
  ppuiLineHeightLg: ppuiLineHeightLg,
  ppuiLineHeightXl: ppuiLineHeightXl,
  ppuiLineHeightXl2: ppuiLineHeightXl2,
  ppuiLineHeightXl3: ppuiLineHeightXl3,
  ppuiLineHeightXl4: ppuiLineHeightXl4,
  ppuiLineHeightXl5: ppuiLineHeightXl5,
  ppuiLineHeightXl6: ppuiLineHeightXl6,
  ppuiOpacityNone: ppuiOpacityNone,
  ppuiOpacityLow: ppuiOpacityLow,
  ppuiOpacityMedium: ppuiOpacityMedium,
  ppuiOpacityHigh: ppuiOpacityHigh,
  ppuiOpacityFull: ppuiOpacityFull,
  ppuiSizeXs: ppuiSizeXs,
  ppuiSizeSm: ppuiSizeSm,
  ppuiSizeMd: ppuiSizeMd,
  ppuiSizeLg: ppuiSizeLg,
  ppuiSizeXl: ppuiSizeXl,
  ppuiSizeXl2: ppuiSizeXl2,
  ppuiSizeText100: ppuiSizeText100,
  ppuiSizeText200: ppuiSizeText200,
  ppuiSizeText300: ppuiSizeText300,
  ppuiSizeText400: ppuiSizeText400,
  ppuiSizeText500: ppuiSizeText500,
  ppuiSizeText600: ppuiSizeText600,
  ppuiSizeText700: ppuiSizeText700,
  ppuiSizeText800: ppuiSizeText800,
  ppuiSizeLine100: ppuiSizeLine100,
  ppuiSizeLine200: ppuiSizeLine200,
  ppuiSizeLine300: ppuiSizeLine300,
  ppuiSizeLine400: ppuiSizeLine400,
  ppuiSizeLine500: ppuiSizeLine500,
  ppuiSizeLine600: ppuiSizeLine600,
  ppuiSizeLine700: ppuiSizeLine700,
  ppuiSizeLine800: ppuiSizeLine800,
  ppuiSpacingXs: ppuiSpacingXs,
  ppuiSpacingSm: ppuiSpacingSm,
  ppuiSpacingMd: ppuiSpacingMd,
  ppuiSpacingLg: ppuiSpacingLg,
  ppuiSpacingXl: ppuiSpacingXl,
  ppuiSpacingXl2: ppuiSpacingXl2,
  ppuiSpacingXl3: ppuiSpacingXl3,
  ppuiSpacingXl4: ppuiSpacingXl4,
  ppuiSpacingXl5: ppuiSpacingXl5,
  ppuiTimeInstant: ppuiTimeInstant,
  ppuiTimeShort: ppuiTimeShort,
  ppuiTimeMedium: ppuiTimeMedium,
  ppuiTimeLong: ppuiTimeLong,
  ppuiV2ColorNeutral100: ppuiV2ColorNeutral100,
  ppuiV2ColorNeutral200: ppuiV2ColorNeutral200,
  ppuiV2ColorNeutral300: ppuiV2ColorNeutral300,
  ppuiV2ColorWhite: ppuiV2ColorWhite,
  ppuiV2ColorGrey50: ppuiV2ColorGrey50,
  ppuiV2ColorGrey300: ppuiV2ColorGrey300,
  ppuiV2ColorGrey400: ppuiV2ColorGrey400,
  ppuiV2ColorGrey500: ppuiV2ColorGrey500,
  ppuiV2ColorGrey600: ppuiV2ColorGrey600,
  ppuiV2ColorBlack: ppuiV2ColorBlack,
  ppuiV2ColorBlue100: ppuiV2ColorBlue100,
  ppuiV2ColorBlue200: ppuiV2ColorBlue200,
  ppuiV2ColorBlue300: ppuiV2ColorBlue300,
  ppuiV2ColorBlue400: ppuiV2ColorBlue400,
  ppuiV2ColorBlue500: ppuiV2ColorBlue500,
  ppuiV2ColorBlue600: ppuiV2ColorBlue600,
  ppuiV2ColorBlue700: ppuiV2ColorBlue700,
  ppuiV2ColorGold: ppuiV2ColorGold,
  ppuiV2ColorMagenta100: ppuiV2ColorMagenta100,
  ppuiV2ColorMagenta200: ppuiV2ColorMagenta200,
  ppuiV2ColorMagenta300: ppuiV2ColorMagenta300,
  ppuiV2ColorMagenta400: ppuiV2ColorMagenta400,
  ppuiV2ColorMagenta500: ppuiV2ColorMagenta500,
  ppuiV2ColorMagenta600: ppuiV2ColorMagenta600,
  ppuiV2ColorOrange100: ppuiV2ColorOrange100,
  ppuiV2ColorOrange200: ppuiV2ColorOrange200,
  ppuiV2ColorOrange300: ppuiV2ColorOrange300,
  ppuiV2ColorOrange400: ppuiV2ColorOrange400,
  ppuiV2ColorOrange500: ppuiV2ColorOrange500,
  ppuiV2ColorOrange600: ppuiV2ColorOrange600,
  ppuiV2ColorGreen100: ppuiV2ColorGreen100,
  ppuiV2ColorGreen200: ppuiV2ColorGreen200,
  ppuiV2ColorGreen300: ppuiV2ColorGreen300,
  ppuiV2ColorGreen400: ppuiV2ColorGreen400,
  ppuiV2ColorGreen500: ppuiV2ColorGreen500,
  ppuiV2ColorGreen600: ppuiV2ColorGreen600,
  ppuiV2ColorYellow100: ppuiV2ColorYellow100,
  ppuiV2ColorYellow200: ppuiV2ColorYellow200,
  ppuiV2ColorYellow300: ppuiV2ColorYellow300,
  ppuiV2ColorYellow400: ppuiV2ColorYellow400,
  ppuiV2ColorYellow500: ppuiV2ColorYellow500,
  ppuiV2ColorYellow600: ppuiV2ColorYellow600,
  ppuiV2ColorPurple100: ppuiV2ColorPurple100,
  ppuiV2ColorPurple200: ppuiV2ColorPurple200,
  ppuiV2ColorPurple300: ppuiV2ColorPurple300,
  ppuiV2ColorPurple400: ppuiV2ColorPurple400,
  ppuiV2ColorPurple500: ppuiV2ColorPurple500,
  ppuiV2ColorPurple600: ppuiV2ColorPurple600,
  ppuiV2ColorIllustrationBlack: ppuiV2ColorIllustrationBlack,
  ppuiV2ColorSkin100: ppuiV2ColorSkin100,
  ppuiV2ColorSkin200: ppuiV2ColorSkin200,
  ppuiV2ColorSkin300: ppuiV2ColorSkin300,
  ppuiV2ColorSkin400: ppuiV2ColorSkin400,
  ppuiV2ColorSkin500: ppuiV2ColorSkin500,
  ppuiV2ColorSkin600: ppuiV2ColorSkin600,
  ppuiV2ColorSkin700: ppuiV2ColorSkin700,
  ppuiV2ColorSkin800: ppuiV2ColorSkin800,
  ppuiV2ColorShadowScrimBlack: ppuiV2ColorShadowScrimBlack,
  ppuiV2SizeText100: ppuiV2SizeText100,
  ppuiV2SizeText300: ppuiV2SizeText300,
  ppuiV2SizeText500: ppuiV2SizeText500,
  ppuiV2SizeText700: ppuiV2SizeText700,
  ppuiV2SizeText900: ppuiV2SizeText900,
  ppuiV2SizeLine100: ppuiV2SizeLine100,
  ppuiV2SizeLine200: ppuiV2SizeLine200,
  ppuiV2SizeLine500: ppuiV2SizeLine500,
  ppuiV2SizeLine700: ppuiV2SizeLine700,
  ppuiV2SizeLine800: ppuiV2SizeLine800,
  ppuiActionMenuWidthMin: ppuiActionMenuWidthMin,
  ppuiActionMenuWidthMax: ppuiActionMenuWidthMax,
  ppuiActionMenuHeightMax: ppuiActionMenuHeightMax,
  ppuiActionMenuBackgroundColor: ppuiActionMenuBackgroundColor,
  ppuiActionMenuBackgroundSpaceTop: ppuiActionMenuBackgroundSpaceTop,
  ppuiActionMenuBackgroundSpaceBottom: ppuiActionMenuBackgroundSpaceBottom,
  ppuiActionMenuBackgroundRadius: ppuiActionMenuBackgroundRadius,
  ppuiActionMenuItemBackgroundSpaceTop: ppuiActionMenuItemBackgroundSpaceTop,
  ppuiActionMenuItemBackgroundSpaceBottom: ppuiActionMenuItemBackgroundSpaceBottom,
  ppuiActionMenuItemBackgroundSpaceLeft: ppuiActionMenuItemBackgroundSpaceLeft,
  ppuiActionMenuItemBackgroundSpaceRight: ppuiActionMenuItemBackgroundSpaceRight,
  ppuiActionMenuItemTextColor: ppuiActionMenuItemTextColor,
  ppuiActionMenuItemIconSize: ppuiActionMenuItemIconSize,
  ppuiActionMenuItemIconColor: ppuiActionMenuItemIconColor,
  ppuiActionMenuItemIconSpaceRight: ppuiActionMenuItemIconSpaceRight,
  ppuiBannerBackgroundSpaceTop: ppuiBannerBackgroundSpaceTop,
  ppuiBannerBackgroundSpaceBottom: ppuiBannerBackgroundSpaceBottom,
  ppuiBannerBackgroundColorCritical: ppuiBannerBackgroundColorCritical,
  ppuiBannerBackgroundColorWarning: ppuiBannerBackgroundColorWarning,
  ppuiBannerTextColorCritical: ppuiBannerTextColorCritical,
  ppuiBannerTextColorWarning: ppuiBannerTextColorWarning,
  ppuiBannerIconColorCritical: ppuiBannerIconColorCritical,
  ppuiBannerIconColorWarning: ppuiBannerIconColorWarning,
  ppuiBannerIconSize: ppuiBannerIconSize,
  ppuiBannerIconAffordanceSize: ppuiBannerIconAffordanceSize,
  ppuiBannerIconSpaceTop: ppuiBannerIconSpaceTop,
  ppuiBannerIconSpaceRight: ppuiBannerIconSpaceRight,
  ppuiButtonBackgroundColorBranded: ppuiButtonBackgroundColorBranded,
  ppuiButtonBackgroundColorBrandedHover: ppuiButtonBackgroundColorBrandedHover,
  ppuiButtonTextColorBranded: ppuiButtonTextColorBranded,
  ppuiCheckboxTextLabelColor: ppuiCheckboxTextLabelColor,
  ppuiCheckboxTextSpaceBottom: ppuiCheckboxTextSpaceBottom,
  ppuiCheckboxIconInfoColor: ppuiCheckboxIconInfoColor,
  ppuiCheckboxIconInfoSpaceLeft: ppuiCheckboxIconInfoSpaceLeft,
  ppuiCheckboxItemSpaceTop: ppuiCheckboxItemSpaceTop,
  ppuiCheckboxItemSpaceBottom: ppuiCheckboxItemSpaceBottom,
  ppuiCheckboxItemIndicatorHeight: ppuiCheckboxItemIndicatorHeight,
  ppuiCheckboxItemIndicatorWidth: ppuiCheckboxItemIndicatorWidth,
  ppuiCheckboxItemIndicatorBackgroundColor: ppuiCheckboxItemIndicatorBackgroundColor,
  ppuiCheckboxItemIndicatorBackgroundColorSelected: ppuiCheckboxItemIndicatorBackgroundColorSelected,
  ppuiCheckboxItemIndicatorBorderSize: ppuiCheckboxItemIndicatorBorderSize,
  ppuiCheckboxItemIndicatorBorderSizeSelected: ppuiCheckboxItemIndicatorBorderSizeSelected,
  ppuiCheckboxItemIndicatorBorderSizeError: ppuiCheckboxItemIndicatorBorderSizeError,
  ppuiCheckboxItemIndicatorBorderColor: ppuiCheckboxItemIndicatorBorderColor,
  ppuiCheckboxItemIndicatorBorderColorSelected: ppuiCheckboxItemIndicatorBorderColorSelected,
  ppuiCheckboxItemIndicatorBorderColorError: ppuiCheckboxItemIndicatorBorderColorError,
  ppuiCheckboxItemIndicatorBorderRadius: ppuiCheckboxItemIndicatorBorderRadius,
  ppuiCheckboxItemIndicatorIconColor: ppuiCheckboxItemIndicatorIconColor,
  ppuiCheckboxItemTextColor: ppuiCheckboxItemTextColor,
  ppuiCheckboxItemTextSpaceLeft: ppuiCheckboxItemTextSpaceLeft,
  ppuiCheckboxFooterSpaceTop: ppuiCheckboxFooterSpaceTop,
  ppuiCheckboxFooterTextColor: ppuiCheckboxFooterTextColor,
  ppuiCheckboxFooterTextColorError: ppuiCheckboxFooterTextColorError,
  ppuiCheckboxFooterIconColorError: ppuiCheckboxFooterIconColorError,
  ppuiCheckboxFooterIconSpaceRight: ppuiCheckboxFooterIconSpaceRight,
  ppuiCoachtipBorderColor: ppuiCoachtipBorderColor,
  ppuiCoachtipBorderWidth: ppuiCoachtipBorderWidth,
  ppuiCoachtipBorderRadius: ppuiCoachtipBorderRadius,
  ppuiCoachtipWidthMax: ppuiCoachtipWidthMax,
  ppuiCoachtipBackgroundColor: ppuiCoachtipBackgroundColor,
  ppuiCoachtipBackgroundSpaceTop: ppuiCoachtipBackgroundSpaceTop,
  ppuiCoachtipBackgroundSpaceBottom: ppuiCoachtipBackgroundSpaceBottom,
  ppuiCoachtipBackgroundSpaceLeft: ppuiCoachtipBackgroundSpaceLeft,
  ppuiCoachtipBackgroundSpaceRight: ppuiCoachtipBackgroundSpaceRight,
  ppuiCoachtipCaretWidth: ppuiCoachtipCaretWidth,
  ppuiCoachtipCaretHeight: ppuiCoachtipCaretHeight,
  ppuiCoachtipCaretOffset: ppuiCoachtipCaretOffset,
  ppuiCoachtipIconCloseColor: ppuiCoachtipIconCloseColor,
  ppuiCoachtipIconCloseSpacingLeft: ppuiCoachtipIconCloseSpacingLeft,
  ppuiCoachtipTextColor: ppuiCoachtipTextColor,
  ppuiCoachtipTextHeadingSpaceBottom: ppuiCoachtipTextHeadingSpaceBottom,
  ppuiCoachtipTextPaginationSpaceRight: ppuiCoachtipTextPaginationSpaceRight,
  ppuiCoachtipFooterButtonSpaceLeft: ppuiCoachtipFooterButtonSpaceLeft,
  ppuiCoachtipFooterSpaceTop: ppuiCoachtipFooterSpaceTop,
  ppuiDropdownBackgroundColor: ppuiDropdownBackgroundColor,
  ppuiDropdownBackgroundSpaceLeft: ppuiDropdownBackgroundSpaceLeft,
  ppuiDropdownBackgroundSpaceRight: ppuiDropdownBackgroundSpaceRight,
  ppuiDropdownBackgroundSpaceTop: ppuiDropdownBackgroundSpaceTop,
  ppuiDropdownBackgroundSpaceTopEntered: ppuiDropdownBackgroundSpaceTopEntered,
  ppuiDropdownBackgroundSpaceBottom: ppuiDropdownBackgroundSpaceBottom,
  ppuiDropdownBackgroundSpaceBottomEntered: ppuiDropdownBackgroundSpaceBottomEntered,
  ppuiDropdownBorderColor: ppuiDropdownBorderColor,
  ppuiDropdownBorderColorError: ppuiDropdownBorderColorError,
  ppuiDropdownBorderSize: ppuiDropdownBorderSize,
  ppuiDropdownBorderSizeError: ppuiDropdownBorderSizeError,
  ppuiDropdownBorderRadius: ppuiDropdownBorderRadius,
  ppuiDropdownIconRightSpaceTop: ppuiDropdownIconRightSpaceTop,
  ppuiDropdownIconRightSpaceLeft: ppuiDropdownIconRightSpaceLeft,
  ppuiDropdownIconRightColor: ppuiDropdownIconRightColor,
  ppuiDropdownTextColor: ppuiDropdownTextColor,
  ppuiDropdownTextLabelColor: ppuiDropdownTextLabelColor,
  ppuiDropdownFooterSpaceTop: ppuiDropdownFooterSpaceTop,
  ppuiDropdownFooterTextColor: ppuiDropdownFooterTextColor,
  ppuiDropdownFooterTextColorError: ppuiDropdownFooterTextColorError,
  ppuiDropdownFooterIconColorError: ppuiDropdownFooterIconColorError,
  ppuiDropdownFooterIconColorSuccess: ppuiDropdownFooterIconColorSuccess,
  ppuiDropdownFooterIconSpaceRight: ppuiDropdownFooterIconSpaceRight,
  ppuiElevationShadowColorLevel1: ppuiElevationShadowColorLevel1,
  ppuiElevationShadowColorLevel2: ppuiElevationShadowColorLevel2,
  ppuiElevationShadowColorLevel3: ppuiElevationShadowColorLevel3,
  ppuiElevationShadowColorLevel4: ppuiElevationShadowColorLevel4,
  ppuiElevationShadowColorLevel5: ppuiElevationShadowColorLevel5,
  ppuiElevationShadowOpacityLevel1: ppuiElevationShadowOpacityLevel1,
  ppuiElevationShadowOpacityLevel2: ppuiElevationShadowOpacityLevel2,
  ppuiElevationShadowOpacityLevel3: ppuiElevationShadowOpacityLevel3,
  ppuiElevationShadowOpacityLevel4: ppuiElevationShadowOpacityLevel4,
  ppuiElevationShadowOpacityLevel5: ppuiElevationShadowOpacityLevel5,
  ppuiElevationShadowPositionHorizontalLevel1: ppuiElevationShadowPositionHorizontalLevel1,
  ppuiElevationShadowPositionHorizontalLevel2: ppuiElevationShadowPositionHorizontalLevel2,
  ppuiElevationShadowPositionHorizontalLevel3: ppuiElevationShadowPositionHorizontalLevel3,
  ppuiElevationShadowPositionHorizontalLevel4: ppuiElevationShadowPositionHorizontalLevel4,
  ppuiElevationShadowPositionHorizontalLevel5: ppuiElevationShadowPositionHorizontalLevel5,
  ppuiElevationShadowPositionVerticalLevel1: ppuiElevationShadowPositionVerticalLevel1,
  ppuiElevationShadowPositionVerticalLevel2: ppuiElevationShadowPositionVerticalLevel2,
  ppuiElevationShadowPositionVerticalLevel3: ppuiElevationShadowPositionVerticalLevel3,
  ppuiElevationShadowPositionVerticalLevel4: ppuiElevationShadowPositionVerticalLevel4,
  ppuiElevationShadowPositionVerticalLevel5: ppuiElevationShadowPositionVerticalLevel5,
  ppuiElevationShadowBlurLevel1: ppuiElevationShadowBlurLevel1,
  ppuiElevationShadowBlurLevel2: ppuiElevationShadowBlurLevel2,
  ppuiElevationShadowBlurLevel3: ppuiElevationShadowBlurLevel3,
  ppuiElevationShadowBlurLevel4: ppuiElevationShadowBlurLevel4,
  ppuiElevationShadowBlurLevel5: ppuiElevationShadowBlurLevel5,
  ppuiFlagWidthXs: ppuiFlagWidthXs,
  ppuiFlagWidthSm: ppuiFlagWidthSm,
  ppuiFlagWidthMd: ppuiFlagWidthMd,
  ppuiFlagHeightXs: ppuiFlagHeightXs,
  ppuiFlagHeightSm: ppuiFlagHeightSm,
  ppuiFlagHeightMd: ppuiFlagHeightMd,
  ppuiFlagBorderWidth: ppuiFlagBorderWidth,
  ppuiFlagBorderColor: ppuiFlagBorderColor,
  ppuiFlagBorderRadiusXs: ppuiFlagBorderRadiusXs,
  ppuiFlagBorderRadiusSm: ppuiFlagBorderRadiusSm,
  ppuiFlagBorderRadiusMd: ppuiFlagBorderRadiusMd,
  ppuiIconbuttonIconSize: ppuiIconbuttonIconSize,
  ppuiIconbuttonIconColor: ppuiIconbuttonIconColor,
  ppuiIconbuttonIconColorInverse: ppuiIconbuttonIconColorInverse,
  ppuiIconbuttonIconSpaceTop: ppuiIconbuttonIconSpaceTop,
  ppuiIconbuttonIconSpaceBottom: ppuiIconbuttonIconSpaceBottom,
  ppuiIconbuttonIconSpaceLeft: ppuiIconbuttonIconSpaceLeft,
  ppuiIconbuttonIconSpaceRight: ppuiIconbuttonIconSpaceRight,
  ppuiMotionBezierEasingX1: ppuiMotionBezierEasingX1,
  ppuiMotionBezierEasingY1: ppuiMotionBezierEasingY1,
  ppuiMotionBezierEasingX2: ppuiMotionBezierEasingX2,
  ppuiMotionBezierEasingY2: ppuiMotionBezierEasingY2,
  ppuiMultiselectgroupTextLabelColor: ppuiMultiselectgroupTextLabelColor,
  ppuiMultiselectgroupTextLabelSpaceBottom: ppuiMultiselectgroupTextLabelSpaceBottom,
  ppuiMultiselectgroupIconInfoColor: ppuiMultiselectgroupIconInfoColor,
  ppuiMultiselectgroupIconInfoSpaceLeft: ppuiMultiselectgroupIconInfoSpaceLeft,
  ppuiMultiselectgroupItemSpace: ppuiMultiselectgroupItemSpace,
  ppuiMultiselectgroupItemBackgroundColor: ppuiMultiselectgroupItemBackgroundColor,
  ppuiMultiselectgroupItemBackgroundColorSelected: ppuiMultiselectgroupItemBackgroundColorSelected,
  ppuiMultiselectgroupItemBackgroundColorSecondarySelected: ppuiMultiselectgroupItemBackgroundColorSecondarySelected,
  ppuiMultiselectgroupItemBackgroundSpaceTop: ppuiMultiselectgroupItemBackgroundSpaceTop,
  ppuiMultiselectgroupItemBackgroundSpaceBottom: ppuiMultiselectgroupItemBackgroundSpaceBottom,
  ppuiMultiselectgroupItemBackgroundSpaceLeft: ppuiMultiselectgroupItemBackgroundSpaceLeft,
  ppuiMultiselectgroupItemBackgroundSpaceRight: ppuiMultiselectgroupItemBackgroundSpaceRight,
  ppuiMultiselectgroupItemBorderSize: ppuiMultiselectgroupItemBorderSize,
  ppuiMultiselectgroupItemBorderSizeSelected: ppuiMultiselectgroupItemBorderSizeSelected,
  ppuiMultiselectgroupItemBorderSizeSecondarySelected: ppuiMultiselectgroupItemBorderSizeSecondarySelected,
  ppuiMultiselectgroupItemBorderSizeError: ppuiMultiselectgroupItemBorderSizeError,
  ppuiMultiselectgroupItemBorderColor: ppuiMultiselectgroupItemBorderColor,
  ppuiMultiselectgroupItemBorderColorSelected: ppuiMultiselectgroupItemBorderColorSelected,
  ppuiMultiselectgroupItemBorderColorError: ppuiMultiselectgroupItemBorderColorError,
  ppuiMultiselectgroupItemBorderRadius: ppuiMultiselectgroupItemBorderRadius,
  ppuiMultiselectgroupItemTextColor: ppuiMultiselectgroupItemTextColor,
  ppuiMultiselectgroupItemTextColorSelected: ppuiMultiselectgroupItemTextColorSelected,
  ppuiMultiselectgroupItemTextColorSecondarySelected: ppuiMultiselectgroupItemTextColorSecondarySelected,
  ppuiMultiselectgroupFooterSpaceTop: ppuiMultiselectgroupFooterSpaceTop,
  ppuiMultiselectgroupFooterTextColor: ppuiMultiselectgroupFooterTextColor,
  ppuiMultiselectgroupFooterTextColorError: ppuiMultiselectgroupFooterTextColorError,
  ppuiMultiselectgroupFooterIconColorError: ppuiMultiselectgroupFooterIconColorError,
  ppuiMultiselectgroupFooterIconSpaceRight: ppuiMultiselectgroupFooterIconSpaceRight,
  ppuiRadiobuttonTextLabelColor: ppuiRadiobuttonTextLabelColor,
  ppuiRadiobuttonTextLabelSpaceBottom: ppuiRadiobuttonTextLabelSpaceBottom,
  ppuiRadiobuttonIconInfoColor: ppuiRadiobuttonIconInfoColor,
  ppuiRadiobuttonIconInfoSpaceLeft: ppuiRadiobuttonIconInfoSpaceLeft,
  ppuiRadiobuttonItemSpaceTop: ppuiRadiobuttonItemSpaceTop,
  ppuiRadiobuttonItemSpaceBottom: ppuiRadiobuttonItemSpaceBottom,
  ppuiRadiobuttonItemIndicatorHeight: ppuiRadiobuttonItemIndicatorHeight,
  ppuiRadiobuttonItemIndicatorWidth: ppuiRadiobuttonItemIndicatorWidth,
  ppuiRadiobuttonItemIndicatorBackgroundColor: ppuiRadiobuttonItemIndicatorBackgroundColor,
  ppuiRadiobuttonItemIndicatorBackgroundColorSelected: ppuiRadiobuttonItemIndicatorBackgroundColorSelected,
  ppuiRadiobuttonItemIndicatorBorderSize: ppuiRadiobuttonItemIndicatorBorderSize,
  ppuiRadiobuttonItemIndicatorBorderSizeSelected: ppuiRadiobuttonItemIndicatorBorderSizeSelected,
  ppuiRadiobuttonItemIndicatorBorderSizeError: ppuiRadiobuttonItemIndicatorBorderSizeError,
  ppuiRadiobuttonItemIndicatorBorderColor: ppuiRadiobuttonItemIndicatorBorderColor,
  ppuiRadiobuttonItemIndicatorBorderColorSelected: ppuiRadiobuttonItemIndicatorBorderColorSelected,
  ppuiRadiobuttonItemIndicatorBorderColorError: ppuiRadiobuttonItemIndicatorBorderColorError,
  ppuiRadiobuttonItemIndicatorDotColor: ppuiRadiobuttonItemIndicatorDotColor,
  ppuiRadiobuttonItemIndicatorDotSize: ppuiRadiobuttonItemIndicatorDotSize,
  ppuiRadiobuttonItemTextColor: ppuiRadiobuttonItemTextColor,
  ppuiRadiobuttonItemTextSpaceLeft: ppuiRadiobuttonItemTextSpaceLeft,
  ppuiRadiobuttonFooterSpaceTop: ppuiRadiobuttonFooterSpaceTop,
  ppuiRadiobuttonFooterTextColor: ppuiRadiobuttonFooterTextColor,
  ppuiRadiobuttonFooterTextColorError: ppuiRadiobuttonFooterTextColorError,
  ppuiRadiobuttonFooterIconColorError: ppuiRadiobuttonFooterIconColorError,
  ppuiRadiobuttonFooterIconSpaceRight: ppuiRadiobuttonFooterIconSpaceRight,
  ppuiSelectionMenuWidthMin: ppuiSelectionMenuWidthMin,
  ppuiSelectionMenuWidthMax: ppuiSelectionMenuWidthMax,
  ppuiSelectionMenuHeightMax: ppuiSelectionMenuHeightMax,
  ppuiSelectionMenuBackgroundColor: ppuiSelectionMenuBackgroundColor,
  ppuiSelectionMenuBackgroundRadius: ppuiSelectionMenuBackgroundRadius,
  ppuiSelectionMenuBackgroundSpaceTop: ppuiSelectionMenuBackgroundSpaceTop,
  ppuiSelectionMenuBackgroundSpaceBottom: ppuiSelectionMenuBackgroundSpaceBottom,
  ppuiSelectionMenuItemBackgroundSpaceTop: ppuiSelectionMenuItemBackgroundSpaceTop,
  ppuiSelectionMenuItemBackgroundSpaceBottom: ppuiSelectionMenuItemBackgroundSpaceBottom,
  ppuiSelectionMenuItemBackgroundSpaceLeft: ppuiSelectionMenuItemBackgroundSpaceLeft,
  ppuiSelectionMenuItemBackgroundSpaceRight: ppuiSelectionMenuItemBackgroundSpaceRight,
  ppuiSelectionMenuItemTextColor: ppuiSelectionMenuItemTextColor,
  ppuiSelectionMenuItemTextSecondaryColor: ppuiSelectionMenuItemTextSecondaryColor,
  ppuiSelectionMenuItemThumbnailSpaceRight: ppuiSelectionMenuItemThumbnailSpaceRight,
  ppuiSelectionMenuItemThumbnailSpaceTopMultiline: ppuiSelectionMenuItemThumbnailSpaceTopMultiline,
  ppuiSelectionMenuItemThumbnailImageWidth: ppuiSelectionMenuItemThumbnailImageWidth,
  ppuiSelectionMenuItemThumbnailImageHeight: ppuiSelectionMenuItemThumbnailImageHeight,
  ppuiSelectionMenuItemThumbnailImageRadius: ppuiSelectionMenuItemThumbnailImageRadius,
  ppuiSelectionMenuItemIconIndicatorSize: ppuiSelectionMenuItemIconIndicatorSize,
  ppuiSelectionMenuItemIconIndicatorColor: ppuiSelectionMenuItemIconIndicatorColor,
  ppuiSelectionMenuItemIconIndicatorSpaceLeft: ppuiSelectionMenuItemIconIndicatorSpaceLeft,
  ppuiSheetBackgroundColor: ppuiSheetBackgroundColor,
  ppuiSheetBackgroundRadius: ppuiSheetBackgroundRadius,
  ppuiSheetScrimColor: ppuiSheetScrimColor,
  ppuiSheetScrimOpacity: ppuiSheetScrimOpacity,
  ppuiSheetGripperColor: ppuiSheetGripperColor,
  ppuiSheetGripperWidth: ppuiSheetGripperWidth,
  ppuiSheetGripperHeight: ppuiSheetGripperHeight,
  ppuiSheetGripperSpaceTop: ppuiSheetGripperSpaceTop,
  ppuiSheetHeaderSpaceTop: ppuiSheetHeaderSpaceTop,
  ppuiSheetHeaderSpaceBottom: ppuiSheetHeaderSpaceBottom,
  ppuiSheetHeaderSpaceLeft: ppuiSheetHeaderSpaceLeft,
  ppuiSheetHeaderSpaceRight: ppuiSheetHeaderSpaceRight,
  ppuiSheetHeaderBackgroundColor: ppuiSheetHeaderBackgroundColor,
  ppuiSheetHeaderIconCloseColor: ppuiSheetHeaderIconCloseColor,
  ppuiSheetHeaderIconCloseSize: ppuiSheetHeaderIconCloseSize,
  ppuiSheetHeaderIconCloseSpaceLeft: ppuiSheetHeaderIconCloseSpaceLeft,
  ppuiSheetHeaderTextHeadingColor: ppuiSheetHeaderTextHeadingColor,
  ppuiSheetAnimationDurationCurveEnter: ppuiSheetAnimationDurationCurveEnter,
  ppuiSheetAnimationDurationCurveExit: ppuiSheetAnimationDurationCurveExit,
  ppuiSheetTextHeadingColor: ppuiSheetTextHeadingColor,
  ppuiSheetTextColor: ppuiSheetTextColor,
  ppuiSheetFooterSpaceTop: ppuiSheetFooterSpaceTop,
  ppuiSheetFooterSpaceBottom: ppuiSheetFooterSpaceBottom,
  ppuiSheetFooterSpaceLeft: ppuiSheetFooterSpaceLeft,
  ppuiSheetFooterSpaceRight: ppuiSheetFooterSpaceRight,
  ppuiSheetFooterColor: ppuiSheetFooterColor,
  ppuiSingleselectgroupTextLabelColor: ppuiSingleselectgroupTextLabelColor,
  ppuiSingleselectgroupTextLabelSpaceBottom: ppuiSingleselectgroupTextLabelSpaceBottom,
  ppuiSingleselectgroupIconInfoColor: ppuiSingleselectgroupIconInfoColor,
  ppuiSingleselectgroupIconInfoSpaceLeft: ppuiSingleselectgroupIconInfoSpaceLeft,
  ppuiSingleselectgroupBorderRadius: ppuiSingleselectgroupBorderRadius,
  ppuiSingleselectgroupBorderSize: ppuiSingleselectgroupBorderSize,
  ppuiSingleselectgroupBorderSizeError: ppuiSingleselectgroupBorderSizeError,
  ppuiSingleselectgroupBorderColor: ppuiSingleselectgroupBorderColor,
  ppuiSingleselectgroupBorderColorError: ppuiSingleselectgroupBorderColorError,
  ppuiSingleselectgroupDividerSize: ppuiSingleselectgroupDividerSize,
  ppuiSingleselectgroupDividerColor: ppuiSingleselectgroupDividerColor,
  ppuiSingleselectgroupItemBackgroundColor: ppuiSingleselectgroupItemBackgroundColor,
  ppuiSingleselectgroupItemBackgroundColorSelected: ppuiSingleselectgroupItemBackgroundColorSelected,
  ppuiSingleselectgroupItemBackgroundColorSecondarySelected: ppuiSingleselectgroupItemBackgroundColorSecondarySelected,
  ppuiSingleselectgroupItemBackgroundSpaceTop: ppuiSingleselectgroupItemBackgroundSpaceTop,
  ppuiSingleselectgroupItemBackgroundSpaceBottom: ppuiSingleselectgroupItemBackgroundSpaceBottom,
  ppuiSingleselectgroupItemBackgroundSpaceLeft: ppuiSingleselectgroupItemBackgroundSpaceLeft,
  ppuiSingleselectgroupItemBackgroundSpaceRight: ppuiSingleselectgroupItemBackgroundSpaceRight,
  ppuiSingleselectgroupItemBorderSizeSelected: ppuiSingleselectgroupItemBorderSizeSelected,
  ppuiSingleselectgroupItemBorderSizeSecondarySelected: ppuiSingleselectgroupItemBorderSizeSecondarySelected,
  ppuiSingleselectgroupItemBorderColorSelected: ppuiSingleselectgroupItemBorderColorSelected,
  ppuiSingleselectgroupItemTextColor: ppuiSingleselectgroupItemTextColor,
  ppuiSingleselectgroupItemTextColorSelected: ppuiSingleselectgroupItemTextColorSelected,
  ppuiSingleselectgroupItemTextColorSecondarySelected: ppuiSingleselectgroupItemTextColorSecondarySelected,
  ppuiSingleselectgroupFooterSpaceTop: ppuiSingleselectgroupFooterSpaceTop,
  ppuiSingleselectgroupFooterTextColor: ppuiSingleselectgroupFooterTextColor,
  ppuiSingleselectgroupFooterTextColorError: ppuiSingleselectgroupFooterTextColorError,
  ppuiSingleselectgroupFooterIconColorError: ppuiSingleselectgroupFooterIconColorError,
  ppuiSingleselectgroupFooterIconSpaceRight: ppuiSingleselectgroupFooterIconSpaceRight,
  ppuiStatesOverlayColorPressed: ppuiStatesOverlayColorPressed,
  ppuiStatesOverlayColorActive: ppuiStatesOverlayColorActive,
  ppuiStatesOverlayColorInversePressed: ppuiStatesOverlayColorInversePressed,
  ppuiStatesOverlayColorInverseActive: ppuiStatesOverlayColorInverseActive,
  ppuiStatesOverlayColorInverseHover: ppuiStatesOverlayColorInverseHover,
  ppuiStatesOverlayColorHover: ppuiStatesOverlayColorHover,
  ppuiStatesOverlayOpacityPressed: ppuiStatesOverlayOpacityPressed,
  ppuiStatesOverlayOpacityActive: ppuiStatesOverlayOpacityActive,
  ppuiStatesOverlayOpacityInversePressed: ppuiStatesOverlayOpacityInversePressed,
  ppuiStatesOverlayOpacityInverseActive: ppuiStatesOverlayOpacityInverseActive,
  ppuiStatesOverlayOpacityInverseHover: ppuiStatesOverlayOpacityInverseHover,
  ppuiStatesOverlayOpacityHover: ppuiStatesOverlayOpacityHover,
  ppuiStatesAnimationDurationPressedDown: ppuiStatesAnimationDurationPressedDown,
  ppuiStatesAnimationDurationPressedUp: ppuiStatesAnimationDurationPressedUp,
  ppuiStatesAnimationDurationHoverOver: ppuiStatesAnimationDurationHoverOver,
  ppuiStatesAnimationDurationHoverOut: ppuiStatesAnimationDurationHoverOut,
  ppuiStatesOutlineInnerColorFocus: ppuiStatesOutlineInnerColorFocus,
  ppuiStatesOutlineInnerColorInverseFocus: ppuiStatesOutlineInnerColorInverseFocus,
  ppuiStatesOutlineInnerSizeFocus: ppuiStatesOutlineInnerSizeFocus,
  ppuiStatesOutlineOuterColorFocus: ppuiStatesOutlineOuterColorFocus,
  ppuiStatesOutlineOuterColorInverseFocus: ppuiStatesOutlineOuterColorInverseFocus,
  ppuiStatesOutlineOuterOpacityInverseFocus: ppuiStatesOutlineOuterOpacityInverseFocus,
  ppuiStatesOutlineOuterSizeFocus: ppuiStatesOutlineOuterSizeFocus,
  ppuiStatesOutlineOffsetSizeFocus: ppuiStatesOutlineOffsetSizeFocus,
  ppuiSwitchTextLabelColor: ppuiSwitchTextLabelColor,
  ppuiSwitchTextLabelSpaceBottom: ppuiSwitchTextLabelSpaceBottom,
  ppuiSwitchIconInfoColor: ppuiSwitchIconInfoColor,
  ppuiSwitchIconInfoSpaceLeft: ppuiSwitchIconInfoSpaceLeft,
  ppuiSwitchIndicatorWidth: ppuiSwitchIndicatorWidth,
  ppuiSwitchIndicatorHeight: ppuiSwitchIndicatorHeight,
  ppuiSwitchIndicatorBackgroundColor: ppuiSwitchIndicatorBackgroundColor,
  ppuiSwitchIndicatorBackgroundColorOn: ppuiSwitchIndicatorBackgroundColorOn,
  ppuiSwitchIndicatorBackgroundSpaceLeft: ppuiSwitchIndicatorBackgroundSpaceLeft,
  ppuiSwitchIndicatorBackgroundSpaceRight: ppuiSwitchIndicatorBackgroundSpaceRight,
  ppuiSwitchIndicatorBorderSize: ppuiSwitchIndicatorBorderSize,
  ppuiSwitchIndicatorBorderSizeOn: ppuiSwitchIndicatorBorderSizeOn,
  ppuiSwitchIndicatorBorderSizeError: ppuiSwitchIndicatorBorderSizeError,
  ppuiSwitchIndicatorBorderColor: ppuiSwitchIndicatorBorderColor,
  ppuiSwitchIndicatorBorderColorOn: ppuiSwitchIndicatorBorderColorOn,
  ppuiSwitchIndicatorBorderColorError: ppuiSwitchIndicatorBorderColorError,
  ppuiSwitchIndicatorHandleColor: ppuiSwitchIndicatorHandleColor,
  ppuiSwitchIndicatorHandleColorOn: ppuiSwitchIndicatorHandleColorOn,
  ppuiSwitchIndicatorHandleSize: ppuiSwitchIndicatorHandleSize,
  ppuiSwitchIndicatorTextColor: ppuiSwitchIndicatorTextColor,
  ppuiSwitchIndicatorTextSpaceLeft: ppuiSwitchIndicatorTextSpaceLeft,
  ppuiSwitchFooterSpaceTop: ppuiSwitchFooterSpaceTop,
  ppuiSwitchFooterTextColor: ppuiSwitchFooterTextColor,
  ppuiSwitchFooterTextColorError: ppuiSwitchFooterTextColorError,
  ppuiSwitchFooterIconColorError: ppuiSwitchFooterIconColorError,
  ppuiSwitchFooterIconSpaceRight: ppuiSwitchFooterIconSpaceRight,
  ppuiTextareaHeightMin: ppuiTextareaHeightMin,
  ppuiTextareaHeightMax: ppuiTextareaHeightMax,
  ppuiTextareaBackgroundColor: ppuiTextareaBackgroundColor,
  ppuiTextareaBackgroundSpaceLeft: ppuiTextareaBackgroundSpaceLeft,
  ppuiTextareaBackgroundSpaceRight: ppuiTextareaBackgroundSpaceRight,
  ppuiTextareaBackgroundSpaceTop: ppuiTextareaBackgroundSpaceTop,
  ppuiTextareaBackgroundSpaceTopEntered: ppuiTextareaBackgroundSpaceTopEntered,
  ppuiTextareaBackgroundSpaceBottom: ppuiTextareaBackgroundSpaceBottom,
  ppuiTextareaBackgroundSpaceBottomEntered: ppuiTextareaBackgroundSpaceBottomEntered,
  ppuiTextareaBorderColor: ppuiTextareaBorderColor,
  ppuiTextareaBorderColorError: ppuiTextareaBorderColorError,
  ppuiTextareaBorderSize: ppuiTextareaBorderSize,
  ppuiTextareaBorderSizeError: ppuiTextareaBorderSizeError,
  ppuiTextareaBorderRadius: ppuiTextareaBorderRadius,
  ppuiTextareaIconRightSpaceTop: ppuiTextareaIconRightSpaceTop,
  ppuiTextareaTextColor: ppuiTextareaTextColor,
  ppuiTextareaTextLabelColor: ppuiTextareaTextLabelColor,
  ppuiTextareaTextLabelSpaceBottomEntered: ppuiTextareaTextLabelSpaceBottomEntered,
  ppuiTextareaTextLabelSpaceTopEntered: ppuiTextareaTextLabelSpaceTopEntered,
  ppuiTextareaCounterBackgroundSpaceTop: ppuiTextareaCounterBackgroundSpaceTop,
  ppuiTextareaCounterBackgroundColor: ppuiTextareaCounterBackgroundColor,
  ppuiTextareaCounterTextColor: ppuiTextareaCounterTextColor,
  ppuiTextareaCounterTextColorError: ppuiTextareaCounterTextColorError,
  ppuiTextareaFooterSpaceTop: ppuiTextareaFooterSpaceTop,
  ppuiTextareaFooterTextColor: ppuiTextareaFooterTextColor,
  ppuiTextareaFooterTextColorError: ppuiTextareaFooterTextColorError,
  ppuiTextareaFooterIconColorError: ppuiTextareaFooterIconColorError,
  ppuiTextareaFooterIconSpaceRight: ppuiTextareaFooterIconSpaceRight,
  ppuiTextinputBackgroundColor: ppuiTextinputBackgroundColor,
  ppuiTextinputBackgroundSpaceLeft: ppuiTextinputBackgroundSpaceLeft,
  ppuiTextinputBackgroundSpaceRight: ppuiTextinputBackgroundSpaceRight,
  ppuiTextinputBackgroundSpaceTop: ppuiTextinputBackgroundSpaceTop,
  ppuiTextinputBackgroundSpaceTopEntered: ppuiTextinputBackgroundSpaceTopEntered,
  ppuiTextinputBackgroundSpaceBottom: ppuiTextinputBackgroundSpaceBottom,
  ppuiTextinputBackgroundSpaceBottomEntered: ppuiTextinputBackgroundSpaceBottomEntered,
  ppuiTextinputBorderColor: ppuiTextinputBorderColor,
  ppuiTextinputBorderColorError: ppuiTextinputBorderColorError,
  ppuiTextinputBorderSize: ppuiTextinputBorderSize,
  ppuiTextinputBorderSizeError: ppuiTextinputBorderSizeError,
  ppuiTextinputBorderRadius: ppuiTextinputBorderRadius,
  ppuiTextinputIconLeftColor: ppuiTextinputIconLeftColor,
  ppuiTextinputIconLeftSpaceRight: ppuiTextinputIconLeftSpaceRight,
  ppuiTextinputIconLeftSpaceTop: ppuiTextinputIconLeftSpaceTop,
  ppuiTextinputIconLeftSpaceLeft: ppuiTextinputIconLeftSpaceLeft,
  ppuiTextinputIconRightSpaceTop: ppuiTextinputIconRightSpaceTop,
  ppuiTextinputIconRightSpaceLeft: ppuiTextinputIconRightSpaceLeft,
  ppuiTextinputIconRightSpaceRight: ppuiTextinputIconRightSpaceRight,
  ppuiTextinputTextColor: ppuiTextinputTextColor,
  ppuiTextinputTextLabelColor: ppuiTextinputTextLabelColor,
  ppuiTextinputFooterSpaceTop: ppuiTextinputFooterSpaceTop,
  ppuiTextinputFooterTextColor: ppuiTextinputFooterTextColor,
  ppuiTextinputFooterTextColorError: ppuiTextinputFooterTextColorError,
  ppuiTextinputFooterTextColorSuccess: ppuiTextinputFooterTextColorSuccess,
  ppuiTextinputFooterIconColorError: ppuiTextinputFooterIconColorError,
  ppuiTextinputFooterIconColorSuccess: ppuiTextinputFooterIconColorSuccess,
  ppuiTextinputFooterIconSpaceRight: ppuiTextinputFooterIconSpaceRight,
  ppuiToastWidthMax: ppuiToastWidthMax,
  ppuiToastBackgroundRadius: ppuiToastBackgroundRadius,
  ppuiToastBackgroundSpaceTop: ppuiToastBackgroundSpaceTop,
  ppuiToastBackgroundSpaceBottom: ppuiToastBackgroundSpaceBottom,
  ppuiToastBackgroundSpaceLeft: ppuiToastBackgroundSpaceLeft,
  ppuiToastBackgroundSpaceRight: ppuiToastBackgroundSpaceRight,
  ppuiToastBackgroundColorSuccess: ppuiToastBackgroundColorSuccess,
  ppuiToastBackgroundColorInformational: ppuiToastBackgroundColorInformational,
  ppuiToastTextColor: ppuiToastTextColor,
  ppuiToastIconSize: ppuiToastIconSize,
  ppuiToastIconColor: ppuiToastIconColor,
  ppuiToastIconSpaceTop: ppuiToastIconSpaceTop,
  ppuiToastIconSpaceRight: ppuiToastIconSpaceRight,
  ppuiToastAnimationDurationActive: ppuiToastAnimationDurationActive,
  ppuiToastAnimationPositionVerticalActive: ppuiToastAnimationPositionVerticalActive,
  ppuiToastAnimationPositionDeltaVerticalEnter: ppuiToastAnimationPositionDeltaVerticalEnter,
  ppuiToastAnimationPositionDeltaVerticalExit: ppuiToastAnimationPositionDeltaVerticalExit,
  ppuiToastAnimationPositionDurationEnter: ppuiToastAnimationPositionDurationEnter,
  ppuiToastAnimationPositionDurationExit: ppuiToastAnimationPositionDurationExit,
  ppuiToastAnimationOpacityActive: ppuiToastAnimationOpacityActive,
  ppuiToastAnimationOpacityInactive: ppuiToastAnimationOpacityInactive,
  ppuiToastAnimationOpacityDurationEnter: ppuiToastAnimationOpacityDurationEnter,
  ppuiToastAnimationOpacityDurationExit: ppuiToastAnimationOpacityDurationExit,
  ppuiTooltipBorderColor: ppuiTooltipBorderColor,
  ppuiTooltipBorderWidth: ppuiTooltipBorderWidth,
  ppuiTooltipBorderRadius: ppuiTooltipBorderRadius,
  ppuiTooltipWidthMax: ppuiTooltipWidthMax,
  ppuiTooltipBackgroundColor: ppuiTooltipBackgroundColor,
  ppuiTooltipBackgroundSpaceTop: ppuiTooltipBackgroundSpaceTop,
  ppuiTooltipBackgroundSpaceBottom: ppuiTooltipBackgroundSpaceBottom,
  ppuiTooltipBackgroundSpaceLeft: ppuiTooltipBackgroundSpaceLeft,
  ppuiTooltipBackgroundSpaceRight: ppuiTooltipBackgroundSpaceRight,
  ppuiTooltipCaretWidth: ppuiTooltipCaretWidth,
  ppuiTooltipCaretHeight: ppuiTooltipCaretHeight,
  ppuiTooltipCaretOffset: ppuiTooltipCaretOffset,
  ppuiTooltipCaretSpaceHorizontal: ppuiTooltipCaretSpaceHorizontal,
  ppuiTooltipTextColor: ppuiTooltipTextColor,
  ppuiTooltipTriggerColor: ppuiTooltipTriggerColor,
  ppuiTooltipTriggerTargetWidth: ppuiTooltipTriggerTargetWidth,
  ppuiTooltipTriggerTargetHeight: ppuiTooltipTriggerTargetHeight,
  ppuiV2ElevationShadowPositionHorizontalLevel1Top: ppuiV2ElevationShadowPositionHorizontalLevel1Top,
  ppuiV2ElevationShadowPositionHorizontalLevel1Bottom: ppuiV2ElevationShadowPositionHorizontalLevel1Bottom,
  ppuiV2ElevationShadowPositionHorizontalLevel2Top: ppuiV2ElevationShadowPositionHorizontalLevel2Top,
  ppuiV2ElevationShadowPositionHorizontalLevel2Bottom: ppuiV2ElevationShadowPositionHorizontalLevel2Bottom,
  ppuiV2ElevationShadowPositionHorizontalLevel3Top: ppuiV2ElevationShadowPositionHorizontalLevel3Top,
  ppuiV2ElevationShadowPositionHorizontalLevel3Bottom: ppuiV2ElevationShadowPositionHorizontalLevel3Bottom,
  ppuiV2ElevationShadowPositionVerticalLevel1Top: ppuiV2ElevationShadowPositionVerticalLevel1Top,
  ppuiV2ElevationShadowPositionVerticalLevel1Bottom: ppuiV2ElevationShadowPositionVerticalLevel1Bottom,
  ppuiV2ElevationShadowPositionVerticalLevel2Top: ppuiV2ElevationShadowPositionVerticalLevel2Top,
  ppuiV2ElevationShadowPositionVerticalLevel2Bottom: ppuiV2ElevationShadowPositionVerticalLevel2Bottom,
  ppuiV2ElevationShadowPositionVerticalLevel3Top: ppuiV2ElevationShadowPositionVerticalLevel3Top,
  ppuiV2ElevationShadowPositionVerticalLevel3Bottom: ppuiV2ElevationShadowPositionVerticalLevel3Bottom,
  ppuiV2ElevationShadowBlurLevel1Top: ppuiV2ElevationShadowBlurLevel1Top,
  ppuiV2ElevationShadowBlurLevel1Bottom: ppuiV2ElevationShadowBlurLevel1Bottom,
  ppuiV2ElevationShadowBlurLevel2Top: ppuiV2ElevationShadowBlurLevel2Top,
  ppuiV2ElevationShadowBlurLevel2Bottom: ppuiV2ElevationShadowBlurLevel2Bottom,
  ppuiV2ElevationShadowBlurLevel3Top: ppuiV2ElevationShadowBlurLevel3Top,
  ppuiV2ElevationShadowBlurLevel3Bottom: ppuiV2ElevationShadowBlurLevel3Bottom,
  ppuiV2ElevationShadowColorLevel1Top: ppuiV2ElevationShadowColorLevel1Top,
  ppuiV2ElevationShadowColorLevel1Bottom: ppuiV2ElevationShadowColorLevel1Bottom,
  ppuiV2ElevationShadowColorLevel2Top: ppuiV2ElevationShadowColorLevel2Top,
  ppuiV2ElevationShadowColorLevel2Bottom: ppuiV2ElevationShadowColorLevel2Bottom,
  ppuiV2ElevationShadowColorLevel3Top: ppuiV2ElevationShadowColorLevel3Top,
  ppuiV2ElevationShadowColorLevel3Bottom: ppuiV2ElevationShadowColorLevel3Bottom,
  ppuiV2ElevationShadowOpacityLevel1Top: ppuiV2ElevationShadowOpacityLevel1Top,
  ppuiV2ElevationShadowOpacityLevel1Bottom: ppuiV2ElevationShadowOpacityLevel1Bottom,
  ppuiV2ElevationShadowOpacityLevel2Top: ppuiV2ElevationShadowOpacityLevel2Top,
  ppuiV2ElevationShadowOpacityLevel2Bottom: ppuiV2ElevationShadowOpacityLevel2Bottom,
  ppuiV2ElevationShadowOpacityLevel3Top: ppuiV2ElevationShadowOpacityLevel3Top,
  ppuiV2ElevationShadowOpacityLevel3Bottom: ppuiV2ElevationShadowOpacityLevel3Bottom,
  ppuiFontWeightLight: ppuiFontWeightLight,
  ppuiFontWeightNormal: ppuiFontWeightNormal,
  ppuiFontWeightBold: ppuiFontWeightBold,
  ppuiGridMediaQuerySm: ppuiGridMediaQuerySm,
  ppuiGridMediaQueryMd: ppuiGridMediaQueryMd,
  ppuiGridMediaQueryLg: ppuiGridMediaQueryLg,
  ppuiGridMediaQueryXl: ppuiGridMediaQueryXl,
  ppuiGridMediaQueryXxl: ppuiGridMediaQueryXxl,
  ppuiGridGutter: ppuiGridGutter,
  ppuiActionMenuItemBackgroundSpaceTopMweb: ppuiActionMenuItemBackgroundSpaceTopMweb,
  ppuiActionMenuItemBackgroundSpaceBottomMweb: ppuiActionMenuItemBackgroundSpaceBottomMweb,
  ppuiAppbadgeIosHeight: ppuiAppbadgeIosHeight,
  ppuiAppbadgeIosWidth: ppuiAppbadgeIosWidth,
  ppuiAppbadgeAndroidHeight: ppuiAppbadgeAndroidHeight,
  ppuiAppbadgeAndroidWidth: ppuiAppbadgeAndroidWidth,
  ppuiIconbuttonMenuSpaceTop: ppuiIconbuttonMenuSpaceTop,
  ppuiSelectionMenuBackgroundRadiusMweb: ppuiSelectionMenuBackgroundRadiusMweb,
  ppuiSelectionMenuItemBackgroundSpaceTopMweb: ppuiSelectionMenuItemBackgroundSpaceTopMweb,
  ppuiSelectionMenuItemBackgroundSpaceBottomMweb: ppuiSelectionMenuItemBackgroundSpaceBottomMweb
});

export { PPUI_TOKENS, ThemeProvider, useTheme };
